module.exports = {
  // заглушка если текста нет
  ' ': ' ',

  // Nav
  'nav.burger': 'Меню',
  'nav.bg': 'Български',
  'nav.ru': 'Руски',
  'nav.en': 'English',
  'nav.zh': '繁體中文',
  'nav.signin': 'Вход',
  'nav.signup': 'Регистрация',
  'nav.forgot_password': 'Забравена парола?',
  'nav.create': 'Регистрация',
  'nav.im_teacher': 'Аз съм учител',
  'nav.im_student': 'Аз съм ученик',
  'nav.register_modal_title': 'Като кого искате да се регистрирате?',

  // Sidebar
  'sidebar.settings': 'Настройки',
  'sidebar.change_password': 'Смяна на парола',
  'sidebar.logout': 'Изход',
  'sidebar.homeworks.await': 'Чакащи задачи',
  'sidebar.homeworks.check': 'За проверка',
  'sidebar.homeworks.history': 'История на задачите',

  // Sign up
  'signup.title': 'Регистрация',
  'signup.subtitle': 'Въведете данни',
  'signup.btn_title': 'Регистриране',
  INVALID_TOKEN: 'Невалиден код.',
  VALIDATION_EMAIL_ALREADY_EXIST: 'Този имейл адрес вече съществува.',
  VALIDATION_EMAIL_ALREADY_USED: 'Този имейл адрес вече се използва',
  'signup.success_message':
    'На посочения имейл е изпратен писмо с линк за потвърждение на регистрацията. Ако не пристигне, върнете се на страницата за регистрация, за да въведете данните отново, или се свържете с техническата поддръжка.',

  // Verify
  'verify.success_message': 'Регистрацията е успешна. За да влезете, ',
  'verify.success_message_link': 'въведете потребителско име и парола',

  // Resend
  'resend.success_message': 'Писмото е изпратено',

  // Sign in
  'signin.title': 'Вход',
  'signin.subtitle': 'Въведете своите данни',
  'signin.password_old': 'Стара парола',
  'signin.password_new': 'Нова парола',
  'signin.password_confirm': 'Потвърдете новата парола',
  'signin.btn_title': 'Вход',
  'signin.repeat':
    'Регистрацията не е потвърдена. Следвайте инструкциите в писмото. {repeat} изпращането на потвърждаващо писмо',

  // Logout
  'logout.title': 'Изход от акаунта',
  'logout.success_message': 'Сесията е прекратена',

  // Forgot password
  'forgotPassword.title': 'Забравена парола?',
  'forgotPassword.subtitle': 'Създайте нова, за да влезете в акаунта',
  'forgotPassword.btn_title': 'Изпращане',
  'forgotPassword.success_message':
    'На посочения имейл е изпратен линк за възстановяване на паролата. Ако не пристигне, върнете се на страницата за възстановяване и опитайте отново, или се свържете с техническата поддръжка.',

  // Reset password
  'resetPassword.title': 'Възстановяване на парола',
  'resetPassword.btn_title': 'Възстановяване',
  'resetPassword.success_message': 'Паролата е възстановена.',

  // Change Password
  'changePassword.title': 'Смяна на парола',
  'changePassword.btn_title': 'Промяна',
  'changePassword.success_message':
    'Паролата е променена успешно. Запомнете я или я запишете',

  // Home
  'home.title': 'ТУК ЩЕ ИМА ПРИВЕТСТВЕН ТЕКСТ И ИЗОБРАЖЕНИЯ',

  // Not Found
  'notFound.title': 'Грешка 404.',
  'notFound.subtitle': 'Страницата не съществува',

  // Forms
  'form.email': 'имейл',
  'form.password': 'парола',
  'form.password_old': 'стара парола',
  'form.password_new': 'нова парола',
  'form.confirm_password': 'потвърждение',
  'form.agree': 'Съгласен съм с ....',
  'form.code': 'Код',
  'form.error_required': 'Задължително',
  'form.error_invalid_email': 'Невалиден имейл адрес',
  'form.error_invalid_phone': 'Невалиден телефон (изискват се 11 цифри)',
  'form.error_password_min': 'Поне {min} символа',
  'form.error_password_letters': 'Трябва да съдържа букви',
  'form.error_password_num': 'Трябва да съдържа цифри',
  'form.error_password_match': 'Паролите не съвпадат',

  // Common
  'common.repeat': 'Повторение',
  'common.success_message': 'Успешно',

  // Notice
  'notice.success': 'Успешно',
  SAVED: 'Запазено',

  // Validation
  MUST_BE_CONTAINS_LETTERS: 'Паролата трябва да съдържа поне 1 латинска буква',
  MUST_BE_CONTAINS_NUMBER: 'Паролата трябва да съдържа цифри',
  MUST_BE_7_CHARACTERS_OR_MORE: 'Паролата трябва да е 7 или повече символа',
  MUST_BE_4_CHARACTERS_OR_MORE: 'Паролата трябва да е 4 или повече символа',
  MUST_BE_NUMERIC: 'Полето трябва да е число',
  MUST_BE_POSITIVE: 'Сумата трябва да е по-голяма от 0',
  REQUIRED: 'Полето е задължително',
  PASSWORD_DO_NOT_MATCH: 'Паролите не съвпадат',
  INVALID_EMAIL_ADDRESS: 'Невалиден имейл адрес',
  UNACCEPTABLE_SIGNS: 'Недопустими символи или интервали',
  INVALID_DATE: 'Датата трябва да е във формат DD.MM.YYYY (ДД.ММ.ГГГГ)',
  TIMETABLE_ERROR: 'Посочете график за изпълнение на задачата',

  // Errors
  INVALID_LOGIN_DATA: 'Невалиден имейл или парола.',
  CANNOT_FOUND_USER_WITH_THIS_EMAIL: 'Не е намерен потребител с такъв имейл.',
  INVALID_OLD_PASSWORD: 'Невярна стара парола',
  EMPTY_OR_VERY_SHORT_PASSWORD: 'Не е посочена или твърде кратка парола',

  // Stub
  simulators: 'Тренажори',
  stub1: 'Справочници',
  reports: 'Отчети',

  // Main Filter (Rules)
  RULE_SIMPLE_SUM: 'Директно броене',
  RULE_FIVE_SUM: 'Формули за 5',
  RULE_TEN_SUM: 'Формула за 10',
  RULE_FIVE_AND_TEN_SUM: 'Формули за 5 и 10',
  NO_MODE: 'Произволни',

  // Menu
  DIRECTORY: 'Справочници',
  ARCHIVE: 'Архив',
  // Student
  STUDENT_TITLE: 'Ученици',
  STUDENT_TITLE_SINGULAR: 'Ученик',
  STUDENT_FORM_LEFT_PATH_TITLE: 'Данни за ученика',
  STUDENT_FORM_RIGTH_PATH_TITLE: 'Данни за родителя',
  STUDENT_TABLE_CREATE_TITLE: 'Добави нов ученик',
  STUDENT_TABLE_SAVE_TITLE: 'Редактиране данните на ученика',
  STUDENT_TABLE_CREATE: 'Ученици без преподавател',
  STUDENT_TABLE_INVITE: 'Изпрати покана',
  STUDENT_TABLE_REGISTER: 'Регистрирай ученик',
  STUDENT_TABLE_SAVE: 'Запази',
  STUDENT_ADD: 'Добави ученик',
  STUDENT_SUCCESS_CREATE_MESSAGE: 'Ученикът е добавен',
  STUDENT_SUCCESS_SAVE_MESSAGE: 'Данните за ученика са актуализирани успешно',

  // Group
  GROUP_TITLE: 'Групи',
  GROUP_TITLE_SINGULAR: 'Група',
  GROUP_FORM_LEFT_PATH_TITLE: 'Основни полета',
  GROUP_FORM_RIGHT_PATH_TITLE: 'Допълнителни полета',
  GROUP_TABLE_CREATE_TITLE: 'Добави нова група',
  GROUP_TABLE_SAVE_TITLE: 'Редактиране данните на групата',
  GROUP_TABLE_CREATE: 'Добави',
  GROUP_TABLE_SAVE: 'Запази',
  GROUP_SUCCESS_CREATE_MESSAGE: 'Групата е добавена',
  GROUP_SUCCESS_SAVE_MESSAGE: 'Групата е актуализирана успешно',

  // School
  SCHOOL_TITLE: 'Училища',
  SCHOOL_FORM_LEFT_PATH_TITLE: 'Данни за ръководителя на училището',
  SCHOOL_FORM_RIGHT_PATH_TITLE: 'Данни за училището',
  SCHOOL_TABLE_CREATE_TITLE: 'Добави ново училище',
  SCHOOL_TABLE_SAVE_TITLE: 'Редактиране данните на училището',
  SCHOOL_TABLE_CREATE: 'Добави',
  SCHOOL_TABLE_SAVE: 'Запази',
  SCHOOL_SUCCESS_CREATE_MESSAGE: 'Училището е добавено',
  SCHOOL_SUCCESS_SAVE_MESSAGE: 'Училището е актуализирано успешно',
  SCHOOL_INFO: 'Информация за училището',

  // Teacher
  TEACHER_TITLE: 'Преподаватели',
  TEACHER_FORM_LEFT_PATH_TITLE: 'Основни полета',
  TEACHER_FORM_RIGHT_PATH_TITLE: 'Допълнителни полета',
  TEACHER_TABLE_CREATE_TITLE: 'Добави нов преподавател',
  TEACHER_TABLE_SAVE_TITLE: 'Редактиране данните на преподавателя',
  TEACHER_TABLE_CREATE: 'Добави',
  TEACHER_TABLE_SAVE: 'Запази',
  TEACHER_SUCCESS_CREATE_MESSAGE: 'Преподавателят е добавен',
  TEACHER_SUCCESS_SAVE_MESSAGE: 'Преподавателят е актуализиран успешно',

  // Homework
  HOMEWORK_TITLE: 'Домашно',
  HOMEWORK_TITLE_SETTINGS: 'Настройки на домашните',
  HOMEWORK_TITLE_SINGULAR: 'Домашна задача',
  HOMEWORK_FORM_LEFT_PATH_TITLE: 'Настройки на параметрите',
  HOMEWORK_FORM_RIGHT_PATH_TITLE: 'Настройки на потребителите',
  HOMEWORK_TABLE_CREATE_TITLE: 'Създай',
  HOMEWORK_TABLE_SAVE_TITLE: 'Редактирай',
  HOMEWORK_TABLE_CREATE: 'Създай',
  HOMEWORK_TABLE_SAVE: 'Запази',
  HOMEWORK_SUCCESS_CREATE_MESSAGE: 'Домашната задача е добавена',
  HOMEWORK_SUCCESS_SAVE_MESSAGE: 'Домашната задача е актуализирана успешно',
  HOMEWORK_STARTED_CARRY_OUT: 'Започна изпълнението на задачата',
  LAST_WEEK_DATES:
    'Проверените домашни се показват за 7 дни спрямо датата на изпълнение',

  // Exams
  EXAMS_TITLE: 'Изпит',
  EXAMS_TITLE_SINGULAR: 'Изпит',
  EXAMS_FORM_LEFT_PATH_TITLE: 'Параметри на изпита',
  EXAMS_FORM_RIGHT_PATH_TITLE: 'Статистика на изпита',
  EXAMS_TABLE_CREATE_TITLE: 'Добави нов изпит',
  EXAMS_TABLE_SAVE_TITLE: 'Редактирай изпит',
  EXAMS_TABLE_CREATE: 'Създай',
  EXAMS_TABLE_SAVE: 'Запази',
  EXAMS_SUCCESS_CREATE_MESSAGE: 'Изпитът е създаден успешно',
  EXAMS_SUCCESS_RESULT: 'Резултатите от изпита са запазени успешно',
  EXAMS_SUCCESS_SAVE_MESSAGE: 'Данните за изпита са актуализирани успешно',
  EXAM_SUCCESS_SAVE: 'Линкът е запазен успешно',

  // Book
  WORKBOOK_BUTTON: 'Създай примери',
  WORKBOOK_TITLE: 'Примери за печат',
  CERTIFICATION_TITLE: 'Сертификация',
  CERTIFICATION_SIMULATE_TITLE: 'Симулация',
  SIMULATE_PAUSE: 'Симулацията на състезанието е спряна. Изчакайте',
  CERTIFICATION_SIMULATE_SAMA_TITLE: 'Симулация SAMA GLOBAL',
  CERTIFICATION_SIMULATE_PAMA_TITLE: 'Симулация PAMA GLOBAL',
  CERTIFICATION_SIMULATE_UAMAP_TITLE: 'Симулация UAMAP',
  CERTIFICATION_EXAM_TITLE: 'Изпит',
  BOOK_TITLE: 'Екипна работа',
  WORKBOOK_TO_PRINT: 'Изпрати за печат',

  // Icons
  CAR_ICON: 'Кола',
  PLANE_ICON: 'Самолет',
  ELEPHANT_ICON: 'Слонче',
  HELICOPTER_ICON: 'Хеликоптер',
  TIGER_ICON: 'Тигърче',
  FOX_ICON: 'Лисиче',
  FAWN_ICON: 'Еленче',
  CROCODILE_ICON: 'Крокодил',
  SQUIRREL_ICON: 'Катериче',
  BEAR_ICON: 'Мечка',
  WOLF_ICON: 'Вълче',
  LEOPARD_ICON: 'Леопард',
  // Common UI
  COLUMN: 'Колони',
  SIMULATORS: 'Тренажори',
  EDIT_PROFILE: 'Редактирай профила',
  EXIT_INSIDE_PROFILE: 'Изход от профила',
  NAME: 'Име',
  SURNAME: 'Фамилия',
  NAME_EN: 'Име на английски',
  SURNAME_EN: 'Фамилия на английски',
  SEX: 'Пол',
  MIDDLE_NAME: 'Бащино име',
  STATUS: 'СТАТУС',
  TRANSACTION_STATUS: 'Статус',
  EXAM_LINK: 'Връзка към Yandex',
  CITY: 'Град',
  EMAIL: 'Имейл адрес',
  EMAIL_SHORT: 'Имейл',
  PHOTO_LINK: 'Връзка към снимката на участника',

  // Main Page Rooms
  MAIN_PAGE_ROOMA_TITLE: 'Бърз достъп: Анзан',
  MAIN_PAGE_ROOMA_DESCRIPTION:
    'В този раздел можете да преглеждате и подобрявате своите умения',
  MAIN_PAGE_ROOMB_TITLE: 'Бърз достъп: Колони',
  MAIN_PAGE_ROOMB_DESCRIPTION:
    'В този раздел можете да преглеждате и подобрявате своите умения',
  MAIN_PAGE_ROOMC_TITLE: 'Бърз достъп: Флаш карти',
  MAIN_PAGE_ROOMC_DESCRIPTION:
    'В този раздел можете да преглеждате и подобрявате своите умения',
  DETAIL: 'Научи повече...',
  SET_YOUR_DATE_OF_BIRTH: 'посочете вашата дата на раждане',

  // Roles
  ROLE_GUEST: 'Неоторизиран',
  ROLE_STUDENT: 'Ученик',
  ROLE_TEACHER: 'Учител',
  ROLE_SCHOOL: 'Училище',
  ROLE_ADMIN: 'Администратор',
  ROLE: 'Тип потребител',

  // Settings
  CABINET: 'Кабинет',
  SETTINGS: 'Настройки',
  BASIC_SETTINGS: 'Основни настройки:',
  ADDITIONAL_SETTINGS: 'Детайлни настройки:',
  TRAINER_SETTINGS: 'Настройки на тренажора',

  // Trainer Parameters
  room: 'Стая',
  amount: 'Брой примери',
  OLIMPIC_SAMPLES_TITLE: 'примера',
  section: 'Раздел',
  animation: 'Анимация',
  windows: 'Брой екрани',
  simulator: 'Тренажор',
  steps: 'Брой числа',
  period: 'Пауза между примерите',
  INTERVAL: 'Скорост на показване',
  interval: 'Скорост на показване',
  ACTIVATE_NEGATIVE: 'Активирай отрицателни числа',
  NEGATIVE_ANSWER: 'Отрицателен краен отговор',
  mode: 'Тема',
  sign: 'Знак',
  bound: 'Преход',
  under: 'от',
  over: 'до',
  of: 'от',
  rule: 'Правило',
  numbers: 'Раздел',
  formulas: 'Формула(и) за число(а): ',
  formulas_once: 'Формула(и):',
  student: 'Ученик',
  students: 'Ученик(и)',
  individ: 'Индивидуално',
  date: 'Дата',
  dates: 'Дата(и)',
  daily: 'Ежедневно',
  daily_over: 'Ежедневно до',
  numbers_of_terms: 'Брой числа',
  numbers_in_example: 'Брой числа в примера',
  comment: 'Коментар',

  // Multiplication / Division
  first_int_available_numbers: 'Първи множител',
  second_int_available_numbers: 'Втори множител',
  order_first_int_available_numbers: 'Разред на първия множител',
  order_second_int_available_numbers: 'Разред на втория множител',
  DIVISION: 'Деление',
  MULTIPLICATION: 'Умножение',
  MULTIDIVISION: 'Умножение/Деление',
  divider: 'Делител',
  dividend: 'Делимо',

  // Animation Types
  FADING: 'Избледняване',
  SLIDE_UP: 'Плъзгане нагоре',
  SLIDE_DOWN: 'Плъзгане надолу',
  SLIDE_LEFT: 'Плъзгане наляво',
  SLIDE_RIGHT: 'Плъзгане надясно',
  BIGGER_FONT: 'По-голям шрифт',
  SMALLER_FONT: 'По-малък шрифт',
  RANDOM_PLACE: 'Случайно място',
  MULTICOLORED_NUMBERS: 'Разноцветни числа',
  NO_ANIMATIONS: 'Без анимации',

  // Training Rooms
  roomA: 'Анзан',
  roomB: 'Колони',
  roomC: 'Флаш карти',
  roomD: 'Таблица на Шулте',
  anzan_title: 'Анзан',
  columns_title: 'Колони',
  cards_title: 'Флаш карти',
  schulte_table_title: 'Таблица на Шулте',

  // Math Parameters
  MINIMUM_RATE: 'Минимален разред на отговора',
  MAXIMUM_RATE: 'Максимален разред на отговора',
  BOTH_ARE_SMALLER: 'И двете са по-малки',
  BOTH_ARE_BIGGER: 'И двете са по-големи',
  OPPOSITE_SIDES: 'От различни страни',

  // Controls
  START: 'Старт',
  STOP: 'Стоп',
  MIX: 'МИКС',
  CLOSE: 'Затвори',
  CHECK: 'Провери',
  ANSWER: 'Отговор',
  ANSWERS: 'Отговори',
  PROGRESS: 'Зареждане',
  ENTER_ANSWER: 'Въведете отговор',

  REPORT_TITLE:
    'Статистиката показва решените задачи по всички раздели: домашна работа и задачи, решени при дистанционно обучение.',
  REPORT_DESCRIPTION:
    'Броят на верните/грешните отговори е показан на лявата вертикална скала, медианните стойности на параметрите: интервал, брой събираеми, разряд на числото - са отбелязани на дясната вертикална скала.',
  NUMBER_OF_TERMS: 'Брой събираеми',
  NUMBER_RANK: 'Разряд на числото',
  digit: 'Разряд на числото',
  FILTER: 'Филтър',
  SUCCESS: 'Вярно',
  FAIL: 'Грешно',
  RATE: 'Оценка',
  ADDRESS: 'Адрес',
  DESCRIPTION: 'Описание',
  FULL_NAME: 'Име и фамилия',
  SUCCESS_ALL: 'Вярно/Общо',
  OPERATION: 'Операции',
  TOTAL_TASKS: 'Общо задачи',
  TASKS: 'Задачи',
  TOTAL_SUCCESS: 'от тях верни',
  REPORT_HOMEWORK:
    'Съкращения: (П) - правило, (Р) - раздел, (Ф) - формула, (З) - знак, (Вп) - Времеви период, (Кч) - брой числа, (Рч) - разряд на числото, (Рр) - режим на количество разряди, (Пм) - първи множител, (Вт) - втори множител',
  ADD_HOMEWORK: 'Създай',
  DELETE_HOMEWORK: 'Изтрий домашна работа',
  DELETE_SELECTED: 'Изтрий избраните',
  SAVE_HOMEWORK: 'Завърши и запази',
  WARNING_HOMEWORK: 'Промените ще засегнат всички ученици!',
  WARNING_HOMEWORK_DELETE: 'Да се изтрие ли домашната работа?',
  WARNING_HOMEWORK_CHECK: 'Да се маркира ли домашната работа като проверена?',
  WARNING_HOMEWORK_EDIT:
    'Ученикът вече е започнал изпълнението на задачата. Резултатът ще бъде нулиран',
  WARNING_HOMEWORK_CANT_EDIT: 'Невъзможно е да се промени изпълнена задача!',
  WARNING_HOMEWORK_CANT_DELETE: 'Невъзможно е да се изтрие изпълнена задача!',
  SHOW_SOLUTION: 'Покажи решение',
  MARK_COMPLETE: 'Оцени',
  GO_TO_HOMEWORK: 'Отиди на задачата',
  FILTER_ALL: 'Всички записи',
  FILTER_TITLE: 'Филтри',
  FILTER_RESET: 'Нулирай филтъра',
  PAGINATION_NEXT: 'Следваща',
  PAGINATION_PREVIOUS: 'Предишна',
  PAGINATION_ROWS_PER_PAGE: 'Записи на страница:',
  PAGINATION_DISPLAY_ROWS: 'от',
  VIEW_COLUMN_TITLE: 'Покажи/скрий колони',
  VIEW_COLUMN_TITLE_AREA: 'Покажи/скрий колони',
  VIEW: 'Покажи',
  HIDE: 'Скрий',
  BODY_NO_MATCH: 'Не е намерен нито един запис',
  BODY_NO_TOOL_TIP: 'Сортирай',
  BODY_NO_COLUMN_HEADER_TOOLTIP: 'Сортиране за ',
  SELECTED_ROWS_TEXT: 'записа маркирани',
  SELECTED_ROWS_TEXT_HOMEWORKS: 'Проверено',
  SELECTED_ROWS_DELETE: 'Изтрий',
  SELECTED_ROWS_DELETE_ARIA: 'Изтрий маркираните записи',
  FILTERING: 'Филтрирай',
  NEGATIVE_NUMBERS: 'Отрицателни числа',
  SECTION_UP_TO_FOUR: 'Броене 1,2,3,4',
  SECTION_UP_TO_FIVE: 'Броене до 5',
  SECTION_UP_TO_SIX: 'Броене до 6',
  SECTION_UP_TO_SEVEN: 'Броене до 7',
  SECTION_UP_TO_EIGHT: 'Броене до 8',
  SECTION_UP_TO_NINE: 'Броене до 9',
  SECTION_MIRROR: 'Огледални числа',
  SECTION_TEN: 'Кръгли числа',
  DIVISION_TABLE: 'Таблица на делението',
  DIVISION_REMAINDER: 'Деление с остатък',
  DIVISION_SIMPLE: 'Просто деление 4D/2D',
  DIVISION_ONE_ITERATE: 'Деление с 1 превъзход 4D/2D',
  DIVISION_MORE_ITERATE: 'Деление с 2 и повече превъзхода 4D/2D',
  DIVISION_SAME: 'Деление с еднакви първи числа 4D/2D',
  DIVISION_BY_ONE: 'Деление с числа на 1 4D/2D',
  DIVISION_RANDOM: 'Произволно деление',
  DIVISION_FIRST: 'Делимо',
  DIVISION_SECOND: 'Делител',
  MULTIPLICATION_TABLE: 'Таблица на умножението',
  MULTIPLICATION_SIMPLE: 'Просто умножение',
  MULTIPLICATION_RANDOM: 'Произволно умножение',
  MULTIPLICATION_ONE_ITERATE: 'Умножение с 0',
  MULTIPLICATION_MORE_ITERATE: 'Умножение с 5',
  MULTIPLICATION_FIRST: 'Множител 1',
  MULTIPLICATION_SECOND: 'Множител 2',
  MULTIPLIER: 'Множител',
  DECIMAL_MODE: 'Десетични',
  SQRT: 'Квадратен корен',
  CURT: 'Кубичен корен',
  SQUARE: 'Число на квадрат',
  CUBE: 'Число на куб',
  ANSWER_DISCHARGE: 'Разряд на отговора',
  ANSWER_DISCHARGE_TYPE: 'Отговор',
  RANDOM_TYPE: 'Случаен',
  SMALL_FISH: 'Минимален разряд на отговора (малка рибка)',
  BIG_FISH: 'Максимален разряд на отговора (голяма рибка)',
  SMALL_MOUSE: 'Минимален разряд на отговора (малка мишка)',
  BIG_MOUSE: 'Максимален разряд на отговора (голяма мишка)',
  ROTATION_TYPE: 'Редуване',
  RANDOM_ROTATION: 'Случайно',
  SINGLE_ROTATION: 'Единично',
  DOUBLE_ROTATION: 'Двойно',
  NUMERALS: 'Цифра(и)',
  RIGHT_ANSWERS: 'Верни отговори',
  RIGHT_ANSWER: 'Верен отговор ',
  WRONG_ANSWERS: 'Грешни отговори',
  SIMULATOR_TYPE: 'Тип тренажор',
  SIMULATOR_SETTINGS: 'Параметри на тренажорите',
  PARAMS: 'Параметри',
  NUMBER_OF_WINDOWS: 'Брой прозорци',
  NUMBER_OF_EXAMPLES: 'Брой примери',
  count: 'Брой примери',
  COMPLETION_TIME: 'Време',
  TIME_LIMIT_VALUE: 'Време за изпълнение (мин:сек)',
  TIME_LIMIT_MODE: 'Режим на времето',
  LIMITED_TIME: 'Ограничено време',
  UNLIMITED_TIME: 'Без ограничение на времето',
  RESTART: 'Отначало',
  CEIL: 'Цяло',
  REMAINDER: 'Остатък',
  SECOND: 'сек',
  TERMS: 'Събираеми',
  base: 'Базис',
  base_side: 'Страни на базиса',
  digits_mode: 'Режим на количество разряди',
  DIGITS_MODE_MIN_RANGE: 'Минимален разряд на отговора',
  DIGITS_MODE_MAX_RANGE: 'Максимален разряд на отговора',
  DIGITS_MODE_RANDOM_RANGE: 'Случаен',
  BASE_SIDE_LESS: 'И двете по-малки от базиса',
  BASE_SIDE_MORE: 'И двете по-големи от базиса',
  BASE_SIDE_DIFF: 'От различни страни на базиса',
  NOT_EXCEED_50: 'без преход',
  NOT_EXCEED_100: 'над 50',
  EXCEED_100: 'над 100',
  DICTATION_AMOUNT: 'Брой примери',
  DICTATION_PERIOD: 'Пауза между примерите',
  DICTATION_START: 'Започни диктовка',
  DICTATION_STOP: 'Спри диктовката',
  DICTATION_NEXT: 'Продължи диктовката',
  SCHOOL_NAME: 'Име',
  SCHOOL_CITY: 'Град',
  SCHOOL_ADDRESS: 'Адрес',
  SCHOOL_METRO_STATION: 'Метро станция',
  SCHOOL_FULL_NAME_OF_HEAD: 'Име и фамилия на ръководителя',
  PHONE: 'Телефон',
  PREVIOUS_PAGE: 'Предишна страница',
  NEXT_PAGE: 'Следваща страница',
  EDIT_DATA: 'Редактирай данните',
  ADD_RECORD: 'Добави запис',
  DELETE_RECORD: 'Изтрий запис',
  RESTORE_USER: 'Възстанови потребителя',
  RECORD_PER_PAGE: 'Редове на страница',
  PASSWORD: 'Парола',
  DATE_REGISTRATED: 'Дата на регистрация',
  DATE_BEGINING: 'Дата на начало',
  DATE_ENDING: 'Дата на завършване',
  DATE_CREATING: 'Дата на създаване',
  DATE_DELETED: 'Дата на изтриване',
  BY_DAYS: 'По дни',
  CREATED: 'Създадено',
  SELECTED: 'Избери...',
  NOT_RECORD: 'Няма записи',
  NOT_FOUND_CATEGORIES_FOR_OLIMPIC:
    'Не са намерени категории за вашата година на раждане',
  DIRECTORY_STUDENTS_TITLE:
    'Тук са всички ученици, които са се регистрирали самостоятелно на платформата, включително и чрез реферални връзки',
  ICON: 'Икона',
  user_guide: 'Ръководство',
  user_online: 'Онлайн: {count}',
  _users: 'потребители',
  _online: 'онлайн',
  RESET: 'Нулирай',
  CHOOSE_THEME: 'Избор на оформление',
  ABACUS_DESCRIPTION:
    'Използвайте виртуалния абакус и дъската за обяснение на нова тема.',
  MARKS: 'Как да поставите метка на абакус',
  ABACUS: 'Абакус',
  DESK: 'Дъска',
  GROUPS: 'Група(и)',
  EMAIL_STUDENT: 'Имейл на ученика',
  NAME_SURNAME_STUDENT: 'Име и фамилия на ученика',
  AGE: 'Възраст',
  EMAIL_PARENT: 'Имейл на родителя',
  NAME_SURNAME_PARENT: 'Име и фамилия на родителя',
  ACTIVE: 'Активен',
  SEND_EMAIL_TO_STUDENT: 'Изпрати логин и парола на този имейл',
  DATEBIRTH: 'Дата на раждане',
  YES: 'Да',
  NO: 'Не',
  SEARCH: 'Търсене',
  SEARCH_STUDENTS: 'Търсене по ученици',
  SEARCH_DATE: 'Търсене по дата',
  REPEAT_PASSWORD: 'Повторете паролата',
  I_AGREE:
    'Съгласен съм с Политиката за поверителност и Правилата за използване',
  WITH_ANSWER: 'Добави отговори в примерите',
  WITH_ANSWER_SEPARATE_SHEET: 'Отговори на отделен лист',
  TO_PRINT: 'Разпечатай',
  CERTIFICATION_PAGE_TITLE_SAMA:
    'SAMA GLOBAL ABACUS & MENTAL ARITHMETIC EXAMINATION',
  CERTIFICATION_PAGE_TITLE_PAMA:
    'PAMA GLOBAL ABACUS & MENTAL ARITHMETIC EXAMINATION',
  CERTIFICATION_PAGE_TITLE_UAMAP: 'Изпит по ментална аритметика UAMAP',
  CERTIFICATION_LEVEL_TIME: 'ВРЕМЕ',
  MIN: 'МИН',
  MENTAL_ARITHMETIC: 'Сметка ментално',
  ARITHMETIC_FOR_CHILDREN: 'Нива за деца',
  ARITHMETIC_FOR_TEACHER: 'Нива за преподаватели',
  FOR_CHILDREN: 'За деца',
  FOR_TEACHER: 'За преподаватели',
  ABACUS_ARITHMETIC: 'Сметка на абакус',
  MENTAL_ARITHMETIC_ADD: 'СМЕТКА МЕНТАЛНО (+,-)',
  ABACUS_ARITHMETIC_ADD: 'СМЕТКА НА АБАКУС (+,-)',
  MENTAL_ARITHMETIC_MULTIPLICATION: 'СМЕТКА МЕНТАЛНО ()',
  ABACUS_ARITHMETIC_MULTIPLICATION: 'СМЕТКА НА АБАКУС ()',
  MENTAL_ARITHMETIC_DIVISION: 'СМЕТКА МЕНТАЛНО (÷)',
  ABACUS_ARITHMETIC_DIVISION: 'СМЕТКА НА АБАКУС (÷)',
  ADD: 'СЪБИРАНЕ',
  CARD: 'ОБРАЗ НА ЧИСЛОТО',
  FIVE: 'СЪСТАВ НА ЧИСЛОТО 5',
  TEN: 'Състав на числото 10',
  NEXT_LEVEL: 'Следваща задача',
  NEXT_TEST: 'Премини друг тест',
  RESULT: 'РЕЗУЛТАТ',
  SCORE: 'Резултат',
  LEVEL: 'Ниво',
  LEVEL_1: 'Ниво 1',
  LEVEL_2: 'Ниво 2',
  LEVEL_3: 'Ниво 3',
  LEVEL_4: 'Ниво 4',
  LEVEL_5: 'Ниво 5',
  LEVEL_6: 'Ниво 6',
  LEVEL_7: 'Ниво 7',
  LEVEL_7_A: 'Ниво 7 A',
  LEVEL_7_B: 'Ниво 7 B',
  LEVEL_8: 'Ниво 8',
  LEVEL_8_A: 'Ниво 8 A',
  LEVEL_8_B: 'Ниво 8 B',
  LEVEL_9: 'Ниво 9',
  LEVEL_9_A: 'Ниво 9 A',
  LEVEL_9_B: 'Ниво 9 B',
  LEVEL_10: 'Ниво 10',
  LEVEL_10_A: 'Ниво 10 A',
  LEVEL_10_B: 'Ниво 10 B',
  LEVEL_11: 'Ниво 11',
  LEVEL_12: 'Ниво 12',
  LEVEL_13: 'Ниво 13',
  LINK_BY_VIDEO: 'Връзка към Диск',
  SAVE_RESULT_BY_TEST: 'Запази резултатите от изпита',
  STARTING_EXAM: 'ПРИСТЪПИ КЪМ ИЗПЪЛНЕНИЕ НА ИЗПИТА',
  ABACUS_TYPE: 'Абакус,',
  MENTAL_TYPE: 'Ментално',
  ADD_TYPE: 'Събиране и изваждане (+, -)',
  MULTIPLICATION_TYPE: 'Умножение ()',
  MULTIPLICATION_TABLE_TYPE: 'Таблица на умножението ()',
  MULTIDIVISION_TYPE: 'Таблица на умножението и делението',
  MULTIDIV_TYPE: 'Умножение и деление',
  DIVISION_TABLE_TYPE: 'Таблица на делението (÷)',
  DIVISION_TYPE: 'Деление (÷)',
  TIE_TYPE: 'Тайбрекър',
  PRINT_CERTIFICATION: 'Разпечатай сертификат',
  CREATE_CERTIFICATION: 'Създай сертификат',
  EXAM_CHECKING: 'Изпитът е на проверка',
  EXAM_STATUS_NOT_FOUND: 'Статусът на изпита не е определен',
  EXAM_WAITING_RUN:
    'Изпитът е създаден и очаква изпълнение в личния кабинет на ученика',
  SET_CODE: 'Въведете вашия код',
  CHECK_CODE: 'Провери',
  CERTIFICATION_NOT_FOUND:
    'Сертификат с такъв код не е намерен, опитайте отново.',
  SCHEDULE_TITLE: 'График',
  PROFILE_TITLE: 'Профил',
  NEWS_TITLE: 'Новини',
  NEWS_EDIT_TITLE: 'Лента',
  NEWS_FEED_TITLE: 'Управление',
  DELEGATES: 'Представители',
  TEAM_MODE_TITLE: 'Отборен режим',
  OLIMPIC_TITLE: 'Олимпиада',
  FOR_PARENTS_TITLE: 'За родители',
  REGISTER: 'Регистрирай',
  HOMEWORK_STATUS: 'Статус',
  COMPLETED: 'Изпълнено',
  OVERCOMPLETE: 'Преизпълнено',
  UNCOMPLETED: 'Не е изпълнено',
  USER: 'Потребител',
  CERTIFICAT: 'Сертификат',
  CATEGORY: 'Категория',
  mark: 'точки',
  'country.AZ': 'Азербайджан',
  'country.AM': 'Армения',
  'country.BY': 'Беларус',
  'country.BE': 'Белгия',
  'country.BG': 'България',
  'country.GB': 'Великобритания',
  'country.DE': 'Германия',
  'country.IL': 'Израел',
  'country.IN': 'Индия',
  'country.IT': 'Италия',
  'country.KZ': 'Казахстан',
  'country.CY': 'Кипър',
  'country.KG': 'Киргизстан',
  'country.KR': 'Южна Корея',
  'country.LB': 'Ливан',
  'country.LT': 'Литва',
  'country.LV': 'Латвия',
  'country.RU': 'Русия',
  'country.RO': 'Румъния',
  'country.US': 'САЩ',
  'country.SA': 'Саудитска Арабия',
  'country.TJ': 'Таджикистан',
  'country.TH': 'Тайланд',
  'country.TQ': 'Турция',
  'country.UZ': 'Узбекистан',
  'country.UA': 'Украйна',
  'country.FR': 'Франция',
  'country.CH': 'Швейцария',
  'country.SE': 'Швеция',
  'country.EE': 'Естония',
  'country.CN': 'Китай',
  'country.TW': 'Тайван',
  'country.CA': 'Канада',
  'country.MY': 'Малайзия',
  'country.HK': 'Хонконг',
  'country.VN': 'Виетнам',
  'country.PS': 'Палестина',
  'country.EG': 'Египет',
  'country.JO': 'Йордания',
  'country.IQ': 'Ирак',
  'country.IR': 'Иран',
  'country.AE': 'ОАЕ',
  'country.AU': 'Австралия',
  'country.ZA': 'Южна Африка',

  COUNTRY: 'Държава',
  EXAM_RESULT: 'Резултат от изпита',
  GENERATE_XLSX: 'Генерирай XLSX',
  GENERATE_SAMA_XLSX: 'Генерирай SAMA XLSX',
  GENERATE_PAMA_XLSX: 'Генерирай PAMA XLSX',
  SAVE_TO_COMPUTER: 'Запази на компютъра',
  CHANGE_RANKS: 'Промени избраните',
  SET_OLIMPIC_RANKS: 'Изберете място, което искате да назначите на участниците',
  STARS: 'Звезди',
  STARS_FOR_HOMEWORK: 'Брой звезди за домашна работа',
  RANK: 'Звание',
  RANK_1: 'Новобранец',
  RANK_2: 'Юниор',
  RANK_3: 'Сметководител',
  RANK_4: 'Знаток',
  RANK_5: 'Ерудит',
  RANK_6: 'Самородок',
  RANK_7: 'Всезнайко',
  RANK_8: 'Уникум',
  RANK_9: 'Вундеркинд',
  RANK_10: 'Гений',
  PLACE_IN_RATING: 'Място в рейтинга',
  NO_RATE: 'Не участва',
  FEATHERS: 'Пера',
  PROGRESS_TO_NEXT_RANK: 'Прогрес до следващото звание',
  SUMM: 'Сума',
  PURPOSE_OF_PAYMENT: 'Предназначение на плащането',
  ENTER_PASSWORD: 'Въведете парола',
  CONFIRM_IS_PARENT:
    'За да потвърдите, че наистина сте родител, въведете действащата парола за този акаунт',
  BALANCE: 'Баланс',
  UCOINS1: 'юкоин',
  UCOINS2: 'юкоина',
  UCOINS5: 'юкоина',
  ACCESS_TO_PLATFORM: 'Достъп до платформата',
  INFINITY_ACCESS_TO_PLATFORM: 'Достъпът до платформата е неограничен',
  WAIT_PAY:
    'Очаква плащане. Страницата на онлайн касата се отвори в друг раздел на браузъра',
  PAY: 'Плати',
  FREE: 'Безплатно',
  CERT_EXAM: 'Изпит за сертификат',
  CERT_EXAMS: 'Изпит за сертификация',
  OLIMPIC_PARTICIPATION: 'Участие в олимпиада',
  OLIMPIC_PARTICIPATIONS: 'Участие в олимпиади',
  CERT_SAMA_GLOBAL_EXAM: 'Брой закупени изпити SAMA GLOBAL',
  CERT_PAMA_GLOBAL_EXAM: 'Брой закупени изпити PAMA GLOBAL',
  CERT_UAMAP_EXAM: 'Брой закупени изпити UAMAP',
  OLIMPIC_ONLINE_PARTICIPATION: 'Брой участия в онлайн олимпиади',
  OLIMPIC_OFFLINE_PARTICIPATION: 'Брой участия в присъствени олимпиади',
  OLIMPIC_SAMA_PARTICIPATION: 'Брой участия в PAMA олимпиади',
  REGISTER_STUDENTS: 'Пакет достъп за ученици',
  PURCHASED: 'Закупено',
  DAYS_ON_PLATFORM: 'Дни на платформата',
  DAYS_LEFT: 'Оставащи дни',
  SUSPENDED: 'Преустановен',
  UNTIL: 'До',
  PROLONG: 'Продължи',
  TOP_UP_ACCOUNT: 'Зареди сметката',
  SAVE_CHANGES: 'Запази промените',
  MOBILE_PHONE: 'Мобилен телефон',
  REFERALS_TITLE: 'Реферална система',
  MANAGEMENT: 'Управление',
  ABOUT_GAMIFICATION: 'За геймификацията',
  UCOINS_TITLE: 'Юкоини',
  STATISTICS: 'Статистика',
  THEMATIC: 'Тематика',
  CONTENT: 'Съдържание',
  BACK: 'Назад',
  ERROR_INCORRECT: 'За съжаление, въведената парола е грешна',
  DEADLINE_ERROR:
    'Посочете до какъв срок ще се назначават ежедневните задачи, но не повече от месец',
  CONFIRM_PAYMENT:
    'След потвърждение средствата от баланса ще бъдат удържани в полза на избраната услуга',
  PRODUCTS_TITLE: 'Цени',
  PRODUCTS_LEARNER: 'Продукти за ученици',
  PRODUCTS_TEACHER: 'Продукти за преподаватели и училища',
  PRODUCTS_SCHOOL: 'Продукти за училища',
  PRODUCTS_TEACHER_ASSOC:
    'Продукти за преподаватели, представители на асоциацията',
  PRODUCTS_SCHOOL_ASSOC: 'Продукти за училища, представители на асоциацията',
  PRODUCTS_ASSOC: 'Продукти за представител на асоциацията',
  CONFIRM_PAY_PRODUCT:
    'Сигурни ли сте, че искате да закупите "{product}" за {price} рубли?',
  CONFIRM_PRODUCT:
    'От баланса ще бъдат удържани {price} юкоина за заплащане на {name}.',
  CONFIRM_PRODUCT_SELF: 'От баланса ще бъдат удържани {price} юкоина.',
  CONFIRM_PAYMENT_PACKAGE:
    'Сигурни ли сте, че искате да платите от закупения ПАКЕТ ДОСТЪПИ за ученика {name}?',
  CONFIRM_BUY_PACK:
    'Сигурни ли сте, че искате да закупите пакети достъпи за {name}?',
  CONFIRM_PACK:
    'Ще бъде закупен пакет достъпи за {count} ученици за {price} юкоина',
  PACKAGES_AMOUNT: 'Пакети достъпи',
  DELETE_PARTICIPANT: 'Изтриване на участници',
  OK: 'Добре',
  CONFIRM: 'Потвърди',
  CONTINUE: 'Продължи',
  CANCEL: 'Отмени',
  REFUSE: 'Отхвърли',
  PURCHASES: 'Покупки',
  currency: 'юкоини',
  currency_short: 'ю.',
  CURRENCY_EQUAL: '1 рубла = 1 юкоин',
  PAYMENT_LIMIT_WARNING:
    'За чуждестранни потребители плащането е възможно само с карти МИР и БЕЛКАРТ',
  PURCHASE_ERROR: 'Възникна грешка',
  PURCHASE_NOT_ENOUGH: 'Недостатъчно средства',
  PURCHASE_SUCCESS: 'Покупката е завършена успешно',
  NOT_ENOUGH_PACK: 'Недостатъчно достъпи в пакета',
  HAVE_ONLINE_OLIMPIC: 'Потребителят вече има достъп до Онлайн олимпиада',
  HAVE_OFFLINE_OLIMPIC: 'Потребителят вече има достъп до Присъствена олимпиада',
  HAVE_MAINTAINERS:
    'Потребителят вече има билет за придружител на Присъствена олимпиада',
  NOT_REGISTERED_OFFLINE_OLIMPIC:
    'Не сте се регистрирали за Присъствена олимпиада',
  REGISTER_STUDENT_ISUFFICIENT_FUNDS:
    'За да регистрирате ученик самостоятелно, закупете подходящ пакет с достъп в раздела за покупки',
  ACCESS_ISUFFICIENT_FUNDS:
    'Достъпът до платформата е изтекъл. Платете го в раздела За родители/Управление',
  ACCESS_NO_DEMO_FUNDS:
    'Платете достъп до платформата в раздела За родители/Управление',
  ACCESS_ISUFFICIENT_FUNDS_TEACHER:
    'Трябва да имате поне 1 ученик с платен достъп. Можете да го платите самостоятелно',
  ACCESS_NO_DEMO_FUNDS_TEACHER:
    'Трябва да имате поне 1 ученик с платен достъп. Можете да го платите самостоятелно',
  SAMA_ACCESS_MESSAGE:
    'За съжаление, сега не можете да участвате в олимпиадата. Моля, закупете достъп до олимпиадата SAMA GLOBAL в раздела',
  PAMA_ACCESS_MESSAGE:
    'За съжаление, сега не можете да участвате в олимпиадата. Моля, закупете достъп до олимпиадата PAMA GLOBAL в раздела',
  NO_ACCESS: 'Този раздел е недостъпен',
  ACCESS_NO_OLIMPIC: 'Необходимо е плащане за участие в олимпиада',
  ENTER_AMOUNT: 'Въведете сумата, с която искате да заредите сметката',
  NOT_SELECTED: 'Не е избрано',
  MENTAL_ARITHMETIC_TITLE: 'Ментална аритметика',
  ROOM_SHORT: 'Каб.',
  TIME: 'време',
  min: 'мин.',
  EACH_Q: 'верен отговор',
  marks: 'точки',
  DATE: 'Дата',
  DATE_FORMAT: 'ДД.ММ.ГГГГ',
  SAVE: 'Запази',
  SAVE_LINK: 'Запази връзката',
  link: 'Връзка',
  ADD_LESSON: 'Добави занятие',
  RECEIVE_BONUSES:
    'Получавайте бонуси за покана на нови ученици или преподаватели',
  REFERAL_LINK_FOR_STUDENTS: 'Реферална връзка за ученици',
  REFERAL_LINK_FOR_TEACHERS: 'Реферална връзка за преподаватели',
  COPY: 'Копирай',
  ABOUT_REFERAL_ADMIN: 'За рефералната система',
  ACHIEVEMENTS: 'Постижения',
  NEW: 'Ново',
  NEW_OR_COMPLETED: 'Ново / Изпълнено',
  TODAY_OR_ALL: 'За днес / Всички',
  ALL_ACHIEVEMENTS: 'Всички постижения',
  HERE_ALL_ACHIEVEMENTS:
    'Тук можете да прегледате всички постижения, които вече сте получили или все още нямате.',
  CLEAR: 'Разбирам',
  WORKS: 'Задачи',
  HOME_WORKS: 'Домашни работи',
  ALL_HOME_WORKS: 'Всички задачи',
  HOME_WORKS_EMPTY: 'Няма домашни работи',
  ADD_TRAIN: 'Добавете тренажор тук',
  COMPLETE: 'Изпълни',
  COMPLETE_OVER: 'Изпълни до',
  FOR_RECEIVE_NEW_ACHIEVEMENTS:
    'За да получите ново, натрупвайте опит и печелете постижения.',
  EXPERIENCE_GRADING: 'Градиране на опита',
  EXPERIENCE_REQUIRED: 'Необходим опит',
  CONFIRM_RESET_FEATHERS:
    'Сигурни ли сте, че искате да нулирате перата на всички участници?',
  FOR_RESET_FEATHERS: 'Натиснете, за да нулирате перата на всички потребители',
  RESET_FEATHERS: 'Нулирай перата',
  CHAMPIONS_CORNER: 'Ъгъл на шампионите',
  PHOTO: 'Снимка',
  OPEN_ALL_OLIMP_CHAMPIONS: 'Виж всички олимпиади',
  RATING: 'Рейтинг',
  TEACHER_RATING: 'Рейтинг на преподавателите',
  STUDENT_RATING: 'Рейтинг на учениците',
  PLACE: 'Място',
  place1: '1-во място',
  place2: '2-ро място',
  place3: '3-то място',
  PLACE_EN: 'място',
  PLACE_LABEL: 'Място (с цифра. 0 - ако е шампион)',
  OPEN_FULL_LIST: 'Отвори пълния списък',
  USERS_LIST: 'Списък с потребители',
  YOUR_PLACE_IN_RATING: 'Сега твоето място в рейтинга',
  FOR_UP_IN_RATING_TEACHER:
    'За да се издигнеш по-нагоре, печели постижения, провеждай занятия и кани на платформата нови ученици и преподаватели',
  FOR_UP_IN_RATING_STUDENT:
    'За да се издигнеш по-нагоре, решавай повече примери и печели пера от постижения',
  STUDENT_NAME: 'Име на ученика',
  TEACHER_NAME: 'Име на преподавателя',
  POINTS: 'Точки',
  TEACHER_ADD_STUDENT:
    'добави вашето дете в списъка на своите ученици. Да се потвърди ли действието?',
  SUBSCRIBE_1_MONTH: 'Подписка за 1 месец',
  FROM_PACKET: 'от пакет',
  SUBSCRIBE_1_MONTH_PACKET: 'Подписка за 1 месец от пакет',
  SUBSCRIBE_6_MONTH: 'Подписка за 6 месеца',
  SUBSCRIBE_12_MONTH: 'Подписка за година',
  SAMA_CERT: 'Сертификация SAMA GLOBAL',
  PAMA_CERT: 'Сертификация PAMA GLOBAL',
  UAMAP_CERT: 'Сертификация UAMAP за ученик',
  UAMAP_CERT_TEACHER: 'Сертификация UAMAP за преподавател',
  SAMA_CERT_SHORT: 'SAMA GLOBAL',
  PAMA_CERT_SHORT: 'PAMA GLOBAL',
  UAMAP_CERT_SHORT: 'UAMAP за ученик',
  UAMAP_CERT_TEACHER_SHORT: 'UAMAP за преподавател',
  MONTH: 'месец',
  MONTHS: 'месеца',
  STUDENT_GENITIVE: 'ученик',
  STUDENTS_GENITIVE: 'ученици',
  SELECT: 'Изберете',
  SELECT_PRODUCT: 'Изберете продукт',
  SELECT_USER: 'Изберете потребител',
  SELECT_LEARNER: 'Избор на ученик',
  SELECT_STUDENT: 'Избор на ученик',
  SELECT_TEACHER: 'Избор на учител',
  SELECT_STUDENTS_AMOUNT: 'Изберете брой участници',
  ACCESS: 'Покупка на достъп до платформата за',
  REPLENISHMENT: 'Зареждане',
  PACKET: 'Покупка на пакет достъпи за',
  ACCESS_FROM_PACKET: 'Покупка на достъп до платформата от пакет',
  SAMA_PAYMENT: 'Покупка на изпит за сертификат SAMA GLOBAL',
  PAMA_PAYMENT: 'Покупка на изпит за сертификат PAMA GLOBAL',
  UAMAP_PAYMENT: 'Покупка на изпит за сертификат UAMAP',
  ONLINE_OLIMPIC_PAYMENT: 'Покупка на участие в онлайн олимпиада',
  OFFLINE_OLIMPIC_PAYMENT: 'Покупка на участие в присъствена олимпиада',
  SAMA_OLIMPIC_PAYMENT: 'Покупка на участие в SAMA GLOBAL олимпиада',
  PAMA_OLIMPIC_PAYMENT: 'Покупка на участие в PAMA GLOBAL олимпиада',
  MAINTAINER_PAYMENT: 'Придружител към олимпиада',

  GAMIFICATION_1:
    'Геймификацията е прилагане на игрови механики в неигрови контексти. Тази система за геймификация има за цел да увеличи ангажираността и интереса на потребителите. Рейтингът се базира на постиженията на преподавателя и неговите ученици. Изпитите, привлечените ученици и броят на занятията подобряват вашия рейтинг.',
  GAMIFICATION_2:
    'Преподавателите могат да печелят постижения, като изпълняват конкретни задачи на платформата.',
  GAMIFICATION_3:
    'Геймификацията е свързана с игри. Тук можете да играете и да се развивате. Тази таб обяснява всички игрови механики на платформата. Перата са точки, които формират рейтинга на учениците. Рейтингът е списък на всички ученици, базиран на техните постижения. Званията са нива, през които преминавате, като печелите постижения. Постиженията са награди за изпълнение на конкретни действия.',
  GAMIFICATION_4: 'Сега нека навлезем в повече подробности',
  GAMIFICATION_5:
    'Рейтингът се актуализира на всеки 3 месеца, което позволява на най-добрите ученици и преподаватели да спечелят ценни награди.',
  GAMIFICATION_6:
    'Рейтингите се базират на спечелени пера (ученици) и рейтингови точки (преподаватели). Повече точки = по-висок ранг. Потребителите с най-висок ранг получават физически и виртуални награди.',
  GAMIFICATION_7: 'Постиженията допринасят за рейтинга на преподавателите.',
  GAMIFICATION_8:
    'За да максимизирате постиженията и рейтинговите точки: полагайте изпити, провеждайте занятия и взаимодействайте с платформата.',
  GAMIFICATION_9:
    'Също така мотивирайте учениците си да се потопят изцяло в света на менталната математика.',
  GAMIFICATION_10:
    'Не забравяйте това и вие, както и учениците, ще достигнете върха на рейтинга!',
  GAMIFICATION_11:
    'Постиженията са забавни значки, спечелени чрез дейности на платформата. Всяко дава точки опит и пера.',
  GAMIFICATION_12:
    'Постиженията стават цветни, когато бъдат спечелени (в момента са в сиви тонове). Можете да прегледате потенциалните награди.',
  GAMIFICATION_13:
    'Рейтинговите точки се печелят чрез ключови действия на платформата и постижения.',
  GAMIFICATION_14:
    'Действията включват провеждане на занятия, задаване на домашни работи и препоръчване на потребители.',
  GAMIFICATION_15:
    'Перата са точки за рейтинга на учениците, спечелени чрез постижения и решаване на задачи (по-трудни задачи = повече пера). Нулират се на всеки 3 месеца, за да се определят нови победители.',
  GAMIFICATION_16:
    'Званията представляват вашия напредък чрез изпълнени задачи и постижения. Повече опит = по-добри звания.',
  GAMIFICATION_17:
    "Всяко ниво ви дава ново звание и уникална рамка за аватара в профила. 'Гений' (Ниво 10) е най-високото.",
  GAMIFICATION_18:
    "Слухът гласи, че не всеки го достига... Ако го направите, считайте платформата за 'завършена' като игра.",
  GAMIFICATION_19:
    'Звездите са оценки от преподавателя за изпълнени домашни работи.',
  GAMIFICATION_20:
    'По-големи усилия = повече звезди. Бъдете най-добрият ученик на вашия преподавател!',
  REFERAL_ADMIN: 'Реферална система',
  MOVE_UCOINS_TO_BALANCE: 'Прехвърляне на юкоини към баланса',
  INVITED_STUDENTS: 'Привлечени ученици',
  ACTIVE_STUDENTS: 'Активни ученици с достъп до платформата',
  INVITED_TEACHERS: 'Привлечени преподаватели',
  EARNED_UCOINS: 'Спечелени юкоини',
  REFERAL_TEXT_1:
    'Рефералната система ви позволява да печелите юкоини безплатно.',
  REFERAL_TEXT_2:
    'Нека нови ученици се регистрират и плащат за абонамент чрез вашата връзка.',
  REFERAL_TEXT_3: 'Ще получите 25 юкоина за всеки ученик.',
  REFERAL_TEXT_4:
    'Печелете безплатни юкоини, като препоръчвате ученици и преподаватели чрез вашата връзка.',
  REFERAL_TEXT_4_S:
    'Печелете безплатни юкоини, когато ученици/преподаватели се регистрират чрез вашата връзка или тази на вашите преподаватели.',
  REFERAL_TEXT_5:
    'Получете 25 юкоина, когато препоръчаните ученици за първи път платят за достъп до платформата.',
  REFERAL_TEXT_5_S:
    'Получете 25 юкоина, когато ученици, препоръчани от вас или вашите преподаватели, платят за първи път.',
  REFERAL_TEXT_6:
    'Получете 50 юкоина, когато преподавателите, които сте препоръчали, имат ученици, които плащат.',
  REFERAL_TEXT_6_S:
    'Получете 50 юкоина, когато преподаватели, препоръчани от вас или вашите преподаватели, имат плащащи ученици.',
  REFERAL_TEXT_7:
    'Спечелете 5% от сумите за зареждане на препоръчаните ученици.',
  REFERAL_TEXT_7_S:
    'Спечелете 2% от зарежданията на ученици, препоръчани от вас или вашите преподаватели.',
  PERSONAL_RATING: 'Личен рейтинг',
  PUBLIC_RATING: 'Общ рейтинг',
  RATING_UPDATE: 'Рейтингът се актуализира ежедневно в 00:00 (Московско време)',
  SCORES_TITLE: 'Рейтингови точки',
  RESULTS: 'Резултати',
  RESULTS_NOTICE:
    'Мястото може да бъде понижено поради липса на видео или минали победители, състезаващи се в същата категория без напредък',
  PARTICIPATE: 'Участвай',
  PARTICIPATE_OFFLINE: 'Участие в присъствена олимпиада',
  OFFLINE_OLIMPIC_PARTICIPATE_NOTICE:
    'Сега попълнете всички полета и кликнете "Участвай", за да се регистрирате за олимпиадата',
  OLIMPIC_REGLAMENT_NOTICE:
    'Моля, внимателно прегледайте регламента на олимпиадата!',
  GET_READY: 'Пригответе се!',
  CURRENT_PING: 'Текущо качество на връзката',
  SEC: 'сек.',
  GOOD: 'Добро',
  NORMAL: 'Нормално',
  WORST: 'Лошо',
  DISCONNECTED: 'Изключено',
  OLIMPIC_TYPE: 'Тип олимпиада',
  olimpic_files: 'Качете файлове и поставете необходимите връзки',
  OLIMPIC_LINK_REQUIRED_NOTIFY:
    'Видео връзката е задължителна, в противен случай призовото място ще бъде понижено! Уверете се, че достъпът до видеото е отворен. Можете също да прикачите връзка след олимпиадата, преди проверката на резултатите',
  OLIMPIC_START_NOTIFY:
    'Пожелаваме ви късмет и победа! След като кликнете бутона "Старт на олимпиадата", няма да можете да се върнете назад, ще имате само 1 опит. Цялата олимпиада трябва да бъде заснета от началото до края. Качете видеото на всяко облачно хранилище и прикачете връзка.',
  OLIMPIC_PRE_RUN_NOTIFY:
    'Потвърдете готовността си и изчакайте края на таймера за подготовка',
  IVE_READ_RULES: 'Прочетох внимателно и съм съгласен с горепосочените правила',
  PREPARED_CAMERA:
    'Готов съм да заснема процеса на преминаване на олимпиадата с видеокамера и съм съгласен да предоставя видео за проверка',
  OLIMPIC_TECHNICAL_REQUIREMENT:
    'Проверете качеството на интернет връзката. Навигацията по раздели, рестартирането и опресняването на страницата са ЗАБРАНЕНИ и участието ви ще бъде прекратено!',
  IM_READY:
    'Готов съм да започна олимпиадата. Нямам проблеми с връзката и няма да напусна страницата, докато резултатът от олимпиадата не бъде запазен.',
  ABOUT_OLIMPIC: 'Олимпиада',
  SAMA_OLIMPIC: 'Sama Global',
  PAMA_OLIMPIC: 'Pama Global',
  PAY_OFFLINE_SELF: 'Купи билет за себе си',
  PAY_OTHER_OFFLINE: 'Купи билет за други',
  OFFLINE_OLIMPIC: 'Присъствена',
  OFFLINE_OLIMPIC_FOR_STUDENT: 'Присъствена за ученик',
  OFFLINE_OLIMPIC_FOR_TEACHER: 'Присъствена за преподавател',
  ONLINE: 'Онлайн',
  ONLINE_LEARNER: 'Онлайн за ученик',
  ONLINE_TEACHER: 'Онлайн за преподавател',
  OLIMPIC_REQUIRE_PAYMENT: 'Изисква се плащане за участие в олимпиада',
  ACCESS_REQUIRE_PAYMENT: 'Изисква се плащане за достъп до платформата',
  REQUIRE_FIELDS: 'Всички полета трябва да бъдат попълнени',
  OLIMPIC_LIST: 'Списък с олимпиади',
  OLIMPIC_NOT_FOUND: 'Не са намерени предстоящи олимпиади',
  WILL_PASS: 'ще се проведе',
  CREATE: 'Добави',
  OLIMPIC_TABLE_CREATE_TITLE: 'Създай олимпиада',
  OLIMPIC_TABLE_EDIT_TITLE: 'Редактирай олимпиада',
  OLIMPIC_TABLE_EDIT_PARTICIPANT: 'Редактирай участник в олимпиада',
  OLIMPIC_SUCCESS_CREATE_MESSAGE: 'Олимпиадата е създадена успешно',
  OLIMPIC_SUCCESS_EDIT_MESSAGE: 'Олимпиадата е актуализирана успешно',
  OLIMPIC_PRINT_TITLE: 'Печат на задачи',
  TIME_BEGINING: 'Начален час',
  TIME_ENDING: 'Краен час',
  OLIMPIC_SIMULATOR: 'Симулатор на олимпиада',
  OLIMPIC_REGLAMENT: 'Регламент',
  OLIMPIC_GROUPS_TASKS: 'Задачи по групи',
  OLIMPIC_START_VIDEO_LINK: 'Връзка към видео преди олимпиадата',
  OLIMPIC_END_VIDEO_LINK: 'Връзка към видео след олимпиадата',
  OLIMPIC_DIPLOMA_LINK_RU: 'Връзка към шаблон за дипломи (руски)',
  OLIMPIC_DIPLOMA_LINK_EN: 'Връзка към шаблон за дипломи (английски)',
  OLIMPIC_GRATITUDE_LINK_RU: 'Шаблон за благодарствено писмо (руски)',
  OLIMPIC_GRATITUDE_LINK_EN: 'Шаблон за благодарствено писмо (английски)',
  CUP_IMAGE_LINK: 'URL на изображение на купа (Ъгъл на шампионите)',
  OLIMPIC_SYLLABUS: 'Силабус',
  OLIMPIC_RUN: 'Старт на олимпиада',
  SHOW_OFFLINE: 'Покажи за присъствена',
  SHOW_ONLINE: 'Покажи за онлайн',
  SHOW_SAMA: 'Покажи за PAMA',
  RESET_OLIMPIC_PAYMENTS: 'Нулирай плащанията за олимпиади',
  RESET_FOR_ONLINE: 'Нулирай за ОНЛАЙН',
  RESET_FOR_OFFLINE: 'Нулирай за ПРИСЪСТВЕНА',
  RESET_FOR_SAMA: 'Нулирай за PAMA',
  CONFIRM_RESET_ALL_OLIMPIC_PAYMENTS:
    'Сигурни ли сте, че искате да нулирате всички плащания за олимпиади?',
  OLIMPIC_PAY_PARTICIPATE: 'Плати за участие в олимпиада',
  OLIMPIC_PAY: 'Плати участие',
  OFFLINE_OLIMPIC_PAY_PARTICIPATE: 'Плати за участие в присъствена олимпиада',
  SAMA_OLIMPIC_PAY_PARTICIPATE: 'Плати за участие в олимпиада SAMA',
  PAMA_OLIMPIC_PAY_PARTICIPATE: 'Плати за участие в олимпиада PAMA',
  OLIMPIC_REGISTERED: 'Вие сте регистрирани за олимпиадата',
  OLIMPIC_STARTS: 'Ще се проведе',
  FROM: 'от',
  TO: 'до',
  OLIMPIC_COMPLETED: 'Олимпиадата вече е приключила',
  DIPLOMS: 'Дипломи',
  DIPLOMA: 'Диплома',
  DIPLOM_FOR_CENTER: 'Диплома за център',
  DIPLOM_FOR_TEACHER: 'Диплома за преподавател',
  CHANGE_TEXT: 'Редактирай текст',
  ENTER_TEXT: 'Въведи текст',
  YEARS: 'години',
  PAYMENT_PARAM_VALIDATION: 'Изисква се избор на продукт',
  PAYMENT_PARAMS_VALIDATION: 'Изисква се избор на продукт и ученик',
  EXAM_REQUIRE_PAYMENT: 'Изисква се плащане за изпит',
  OVERALL_SCORE: 'Общ резултат',
  SCORE_O: 'Резултат',
  SCORE_MAX: 'Максимален резултат',
  STAGE: 'Етап',
  stage_num: 'Етап {stage}',
  OLIMPIC_PRINT_CLOSED_FOR_TEACHER:
    'Изисква се минимум един платен ученик, за да можете да печатате задачи за олимпиадата',
  OLIMPIC_PRINT_CLOSED_FOR_STUDENT:
    'Изисква се плащане за достъп до платформата, за да можете да печатате задачи за олимпиадата',
  PARTICIPANTS: 'Участници',
  OFFLINE_OLIMPIC_PARTICIPANTS: 'Участници в присъствена олимпиада',
  PARTICIPANT_OVZ: 'Участник с увреждания',
  REQUIRED_OVZ_DOCUMENT:
    'Моля, предоставете удостоверение за увреждане (съответстващо на правилата на Асоциацията) чрез Telegram',
  OVZ: 'Увреждания',
  ASSOCIATION: 'Асоциация',
  export: 'Експорт',
  MAINTAINER: 'Придружител',
  TSHORT: 'Тениска',
  TSHIRT_SIZE: 'Размер на тениската',
  MAINTAINERS_COUNT: 'Брой придружители',
  MAINTAINERS_LIMIT_FOR_1_PARTICIPANT:
    'Лимит на билетите за придружители на 1 участник',
  OLIMPIC_PARTICIPANT_SUCCESS_EDIT_MESSAGE:
    'Участникът в олимпиадата е актуализиран',
  OLIMPIC_PARTICIPANTS_SUCCESS_EDIT_MESSAGE:
    'Участниците в олимпиадата са актуализирани',
  PARTICIPANT_NOT_FOUND: 'Участникът не е намерен',
  PAID: 'Платено',
  PAID_6_MONTHS: 'Изисква се плащане за 6 месеца',
  REQUIRED_6_MONTHS_OLIMPIC:
    'Олимпиадата е достъпна само за активни потребители. Трябва да сте имали платен достъп до платформата през последните 6 месеца. Можете да закупите достъп за следващите 6 месеца сега. Моля, прегледайте правилата на олимпиадата.',
  PAID_9_MONTHS: 'Изисква се плащане за 9 месеца',
  REQUIRED_9_MONTHS_OLIMPIC:
    'Олимпиадата е достъпна само за активни потребители. Трябва да сте имали платен достъп до платформата през последните 9 месеца. Можете да закупите достъп за следващия период «1-годишен абонамент» сега. Моля, прегледайте правилата на олимпиадата.',
  CONFIRM_DELETE_USER:
    'ВНИМАНИЕ! Сигурни ли сте, че искате да изтриете този потребител? ТОВА НЕ МОЖЕ ДА БЪДЕ ОТМЕНЕНО!',
  CONFIRM_DELETE_USERS:
    'ВНИМАНИЕ! Сигурни ли сте, че искате да изтриете {count} потребители? ТОВА НЕ МОЖЕ ДА БЪДЕ ОТМЕНЕНО!',
  CONFIRM_ALIVE_USER:
    'Сигурни ли сте, че искате да възстановите този потребител?',
  DELETED_USERS_TITLE: 'Изтрити потребители',
  CONFIRM_DELETE_OLIMPIC:
    'Сигурни ли сте, че искате да изтриете тази олимпиада?',
  CONFIRM_CLEAR_RESULT:
    'Сигурни ли сте, че искате да нулирате резултатите на участника?',
  CONFIRM_DELETE_OFFLINE_PARTICIPANT:
    'Сигурни ли сте, че искате да изтриете билета на участника и неговите придружители?',
  CONFIRM_DELETE_ONLINE_PARTICIPANT:
    'Сигурни ли сте, че искате да изтриете участника?',
  OLIMPIC_ENCOURAGE:
    'Пожелаваме ви късмет и победа! След като кликнете бутона "СТАРТ НА ОЛИМПИАДАТА", няма да можете да се върнете назад, ще имате само 1 опит. Цялата олимпиада от началото до края трябва да бъде заснета. Качете видеото на всяко облачно хранилище и прикачете връзка.',
  OLIMPIC_LINK_WARN:
    'Видео връзката е задължителна, в противен случай призовото място ще бъде понижено! Уверете се, че достъпът до видеото е отворен. Прикачването на връзка е възможно и след олимпиадата, преди проверката на резултатите',
  LINK_NOTICE:
    'Връзката може да бъде прикачена по-късно в раздела Олимпиада. Моля, обърнете внимание, че без видео резултатът няма да бъде зачетен.',
  OLIMPIC_CONGRATS: 'Поздравления, опитът ви приключи',
  END: 'Край',
  BOLD: 'Удебелен',
  custom_text: 'Текст',
  CHAMPION: 'Шампион',
  CHAMPION_EN: 'Шампион',
  COMPETITOR: 'Участник',
  COMPETITOR_EN: 'Участник',
  AddMENTAL: 'Ментално събиране и изваждане',
  AddABACUS: 'Събиране и изваждане на абакус',
  Card: 'Визуализация на число',
  MultiABACUS: 'Умножение на абакус',
  DivisionABACUS: 'Деление на абакус',
  Multi: 'Таблица на умножението',
  Division: 'Таблица на делението',
  MultiMENTAL: 'Ментално умножение',
  DivisionMENTAL: 'Ментално деление',
  MultiDivision: 'Таблица на умножение и деление',
  AddMENTALen: 'Ментално събиране и изваждане',
  AddABACUSen: 'Събиране и изваждане на абакус',
  Carden: 'Флаш карти',
  MultiABACUSen: 'Умножение на абакус',
  DivisionABACUSen: 'Деление на абакус',
  Multien: 'Таблица на умножението',
  Divisionen: 'Таблица на делението',
  MultiMENTALen: 'Ментално умножение',
  DivisionMENTALen: 'Ментално деление',
  MultiDivisionen: 'Таблица на умножение и деление',
  OPEN_TICKET_SALES: 'Отвори продажбата на билети',
  SHOW_RESULTS: 'Покажи резултатите',
  SHOW_DIPLOMS: 'Покажи дипломите',
  ACTIVE_SIMULATION: 'Активирай симулация',
  SHOW_RATING: 'Покажи рейтинга',
  SHOW_PRINT: 'Разреши печат на задачи',
  ACTIONS: 'Действия',
  ACTION: 'Действие',
  DIPLOM_EN: 'Диплома (английски)',
  DIPLOM_RU: 'Диплома (руски)',
  AFTER: 'след',
  DICTANT_SETTINGS: 'Настройки на диктанта',
  OLIMPIC_SUCCESS_RESULT: 'Резултатите от олимпиадата са запазени успешно',
  PHONE_INVALID: 'Невалиден или липсващ телефонен номер.',
  EXAM_NEW: 'Изпитът е създаден',
  EXAM_FINISHED: 'Изпитът е завършен',
  EXAM_IN_PROCESS: 'Изпитът е в процес на изпълнение',
  EXAM_ARCHIVE: 'Изпитът е в архива',
  EXAM_SUCCESSFUL: 'Изпитът е положен успешно',
  EXAM_SUCCESSFUL_RUN: 'Вие положихте изпита, очаквайте сертификата си',
  EXAM_FAILURE: 'Изпитът не е положен',
  EXAM_FAILURE_RUN: 'Не положихте изпита, продължавайте да тренирате',
  EXAM_NOT_REQUIRED_NUMBER_OF_POINTS:
    'Потребителят не достигна необходимия брой точки (>=70 за всяка задача)',
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION_FOR_SAMA:
    'Преподавателите не могат да издават сертификати SAMA - само администратор',
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION_FOR_PAMA:
    'Преподавателите не могат да издават сертификати PAMA - само администратор',
  EXAM_TEACHER_DNOT_RUN_CERTIFICATION:
    'Преподавателите не могат да издават сертификати - само администратор',
  new: 'Ново',
  process: 'В процес на изпълнение',
  success: 'Изпълнено',
  overfill: 'Преизпълнено',
  left_tasks: 'Оставащи',
  HIT_1: 'Впечатли преподавателя си!',
  HIT_2: 'Удиви всички!',
  HIT_3: 'Вдигни летвата!',
  HIT_4: 'Можеш ли още по-добре?',
  FLASH_CARD: 'Флаш карти',
  FLASH_BATTLE: 'Флаш-битка',
  ANZAN: 'Анзан',
  ANZAN_VIRTUAL: 'Виртуален анзан',
  SOUND: 'Звук',
  AUTOREPEAT: 'Автоповторение',
  DICTANT: 'Диктант',
  SHOW_ANSWERS: 'Отговори на диктанта',
  SHOW_EXAMPLES: 'Покажи пример(и)',
  HIDE_EXAMPLES: 'Скрий пример(и)',
  SHOW_ANSWER: 'Покажи отговори',
  HIDE_ANSWER: 'Скрий отговори',
  EXAMPLE: 'Пример',
  max_discharge: 'Максимален разряд на отговора (голяма рибка)',
  min_discharge: 'Минимален разряд на отговора (малка рибка)',
  ABACUS_FULL: 'Покажи целия абакус',
  ABACUS_ALIGN: 'Смятай от центъра на абакуса',
  // MODALS
  UPDATE_MODAL_TITLE: 'Уважаеми потребителю!',
  UPDATE_MODAL_MESSAGE:
    'Ние актуализирахме нашата платформа! Поправихме някои проблеми и добавихме нови възможности. Обновете страницата, за да започнете да ги използвате!',
  UPDATE: 'Обнови',
  SKIP: 'По-късно',
  EXAMPLE_EXECUTED_CONGRATS: 'Поздравления, тази задача е изпълнена!',
  TIME_OVERWRITE_WARNING:
    'Обърнете внимание: в тренажора на Шулте всеки нов резултат презаписва предишния, дори ако времето за изпълнение се е увеличило.',
  GO_NEXT_EXAMPLES: 'Премини към други задачи',
  GO_LINK: 'Премини',
  CONTINUE_EXAMPLE: 'Продължи тази задача',
  // Teamwork
  TEAMWORK_USERS_INVITE_TITLE: 'Поканете ученици, които в момента са онлайн!',
  TEAMWORK_INVITE_TITLE: '{user} ви кани на занятие!',
  INVITE_ACTION: 'Покани',
  INVITED: 'Поканен',
  ACCEPT: 'Приеми',
  DECLINE: 'Отхвърли',
  TEAMWORK_KICK_TITLE:
    'Сигурни ли сте, че искате да изключите {user} от занятието?',
  'teamwork.user.joined': 'Ученикът е свързан',
  'teamwork.user.left': 'Ученикът напусна тренажора',
  // Painter
  CLEAR_DRAWING: 'Изчисти',
  SIZE: 'Размер',
  COLOR: 'Цвят',
  PIXELS_SHORT: 'px',
  // Referral Clues
  S_REFERRAL_CLUE:
    'Споделете връзката с приятели! Когато се регистрират и платят за достъп, ще получите 25 юкоина',
  T_TO_S_REFERRAL_CLUE_1:
    'Споделете с вашите ученици и всички останали! Когато се регистрират и платят, ще получите 25 юкоина!',
  T_TO_S_REFERRAL_CLUE_2: 'Забележка: ',
  T_TO_S_REFERRAL_CLUE_3:
    'вашите ученици все пак трябва да бъдат свързани с вас чрез Справочници/Ученици/Добави от списък',
  T_TO_T_REFERRAL_CLUE:
    'Изпратете на познати преподаватели! Когато се регистрират и свържат ученици, които плащат, ще получите 50 юкоина!',
  // System Clues
  RATING_CLUE: 'Рейтингът се обновява всеки ден в 00:00 (Московско време)',
  S_ACCESS_CLUE: 'Достъпът до цялата платформа започва веднага след плащане',
  S_CERT_EXAM_CLUE:
    'След плащане на сертификата уведомете преподавателя/администратора за насрочване на изпит',
  OLIMPIC_PARTICIPATION_CLUE:
    'За участие в олимпиадите се изисква отделно плащане. Симулациите и онлайн участието са достъпни само при активен достъп до платформата',
  // Balance Clues
  BALANCE_CLUE_1: 'Всички цени са в юкоини (1 юкоин = 1 рубла). ',
  BALANCE_CLUE_2: "За покупка заредете баланса чрез 'Зареди сметката'. ",
  BALANCE_CLUE_3:
    'Не забравяйте да извършите покупка, за да активирате платените функции!',
  // Teacher Access Clues
  T_ACCESS_CLUE_1: 'Тук закупувате достъп за ученици. ',
  T_ACCESS_CLUE_2:
    'Платените функции се отключват веднага за закупения период. ',
  T_ACCESS_CLUE_3: 'За плащане от ',
  T_ACCESS_CLUE_4: 'предварително закупени пакети достъпи ',
  T_ACCESS_CLUE_5: "изберете само '1 месец от пакет'!",
  // Certification Clues
  T_CERT_EXAM_CLUE:
    'След плащане на сертификата създайте изпит за ученика в раздел "Сертификация/Изпит" или се обърнете към администратора. Преподавателите могат да полагат изпит UAMAP само след обучение',
  CERT_EXAM_CLUE_2: "Раздел 'Изпит' изисква активен достъп до платформата",
  // Package Clues
  ACCESS_PACKET_CLUE_1:
    'Достъп за ученици на месец на изгодна цена (на ученик). ',
  ACCESS_PACKET_CLUE_2:
    'Пакетите нямат ограничения за съхранение и се сумират. Можете по всяко време да удължите достъпа на учениците от пакета. ',
  ACCESS_PACKET_CLUE_3:
    "Остатъкът вижте в Достъп до платформата 'Подписка за 1 месец от пакет (Оставащи: ...)'",
  // Homework Clues
  NEW_HOMEWORK_CLUE_1:
    'Тук се виждат само текущите настройки на домашните задачи, които са актуални. Щом срокът на ДЗ изтече, то изчезва от списъка. ',
  NEW_HOMEWORK_CLUE_2:
    'Можете да редактирате задачите, за да не дублирате твърде много ДЗ за един ученик. ',
  NEW_HOMEWORK_CLUE_3: "Изпълнените ДЗ вижте в раздел 'За проверка'",
  CREATE_HOMEWORK_CLUE:
    'При създаване имайте предвид, че ДЗ се счита за изпълнено, само ако са изпълнени ВСИЧКИ тренажори до зададения брой примери. ',
  DAILY_HOMEWORK_CLUE:
    "Настройката 'Ежедневно' задава ДЗ като ново всеки ден. Ако ученикът не е завършил до края през деня (няма статус Изпълнено или Преизпълнено), не се запазва. Ние сме за позитивна мотивация - дългът по ДЗ не се показва никъде. ",
  DAILY_MAX_HOMEWORK_CLUE:
    'В момента не е възможно да се създадат повече от {count} ежедневни домашни задачи. Колкото повече ученици - толкова по-висок е лимитът',
  DEADLINE_HOMEWORK_CLUE:
    "Ако е важно просто да доведете ДЗ до статус изпълнено за дълго време, изберете настройката 'Изпълни до'",
  // Homework Completion
  COMPLETED_HOMEWORK_CLUE_1:
    'Изпълнени ДЗ се считат, когато има статус Изпълнено или Преизпълнено.',
  COMPLETED_HOMEWORK_CLUE_2:
    'Попадат тук на следващия ден след изпълнение от ученика. Тъй като на ученика се дава възможност да преизпълни зададения обем ДЗ в рамките на деня след като го е изпълнил. Обърнете внимание на броячите на изпълнените и преизпълнените при проверка. ',
  COMPLETED_HOMEWORK_CLUE_3: 'Оценете ДЗ със звезди и коментар',
  // Exam Requirements
  EXAM_CLUE:
    'Процесът на полагане на изпит трябва да бъде заснет на видео. И да се прикачи връзка към него.',
  EXAM_CLUE_2:
    'Качете видеото в облачно хранилище (Google Drive, Yandex Disk и т.н.) и споделете връзката.',
  // Abacus Interaction
  ABACUS_CLUE:
    'При натискане на напречната греда на абакуса се появява метка. При повторно натискане - метката се премахва.',
  // Competition Management
  CREATE_PARTICIPANT: 'Създай нов участник',
  EDIT_PARTICIPANT: 'Редактирай участник',
  SELECT_COUNTRY: 'Избор на държава',
  SELECT_CATEGORY: 'Избор на категория',
  OLIMPIC_CHOOSE_CATEGORY:
    'Изберете категория строго по-висока, ако преди това сте печелили награда. При неспазване на правилата е възможна дисквалификация',
  DELEGATE: 'Представител',
  CREATE_DELEGATE: 'Създай нов представител',
  EDIT_DELEGATE: 'Редактирай представител',
  SET_PLACE: 'Назначи място',
  CLEAR_RESULT: 'Изчисти резултатите',
  // Information Sections
  REGULATIONS: 'Регламент',
  INFORMATION: 'Информация',
  DIPLOMAS: 'Дипломи',
  MENTAL: 'Ментално',
  SELECT_PLACE: 'Избери място',
  // Technical
  SOUND_CLUE: 'Синтезът на речта не се поддържа във вашия браузър',
  // Data Table
  'table.no-match': 'За съжаление не са намерени подходящи записи',
  'table.tooltip': 'Сортирай',
  'table.next': 'Следваща страница',
  'table.previous': 'Предишна страница',
  'table.rows_per_page': 'Редове на страница:',
  'table.display_rows': 'от',
  'table.jump_to_page': 'Премини на страница:',
  'table.search': 'Търсене',
  'table.download_csv': 'Изтегли',
  'table.print': 'Печат',
  'table.view_columns': 'Преглед на колони',
  'table.filter_table': 'Филтри',
  'table.all': 'Всички',
  'table.filter_title': 'Филтри',
  'table.reset': 'Нулирай',
  'table.title': 'Видими колони',
  'table.title_aria': 'Покажи/Скрий колони',
  'table.text': 'избран(о)',
  'table.delete': 'Изтрий',
  'table.delete_aria': 'Изтрий избраните редове',
  // Products
  'product.type_1.1': 'Достъп до платформата за 1 месец',
  'product.type_1.6': 'Достъп до платформата за 6 месеца',
  'product.type_1.12': 'Достъп до платформата за 12 месеца',
  'product.type_2.10': 'Пакет достъпи за 10 ученици',
  'product.type_2.25': 'Пакет достъпи за 25 ученици',
  'product.type_2.50': 'Пакет достъпи за 50 ученици',
  'product.type_3.1': 'Достъп от пакет',
  'product.type_4.0': 'Достъп до изпит PAMA',
  'product.type_5.0': 'Достъп до изпит UAMAP',
  'product.type_6.0': 'Достъп до онлайн олимпиада',
  'product.type_7.0': 'Достъп до присъствена олимпиада',
  'product.type_8.0': 'Билет за придружител',
  'product.type_9.0': 'Достъп до олимпиада PAMA',
  'product.type_10.0': 'Достъп до присъствена олимпиада PAMA Global',
  'product.type_11.0': 'Билет за придружител',
  // Exams
  ONLY_MENTAL: 'само МЕНТАЛНО',
  // Teacher Level Exams
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_1: '10 примера 3-4D10R абакус',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_2: '20 примера 3D3D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_3: '20 примера 4-5D/2-3D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_4: '10 примера 2D6R',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_1_SECTION_5: '20 примера 2D1D, 3D/1D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_1: '10 примера 2-3D10R абакус',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_2: '20 примера 2D*2D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_3: '20 примера 3-4D/1D',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_4: '10 примера 1D7R',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_2_SECTION_5: '10 примера 1-2D5R',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_1:
    '50 примера таблица на умножението',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_2:
    '50 примера таблица на делението',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_3: '20 примера 1-2D10R абакус',
  ABACUS_ARITHMETIC_ADD_TEACHER_LEVEL_3_SECTION_4: '20 примера 1D6R',
  // Student Level Exams (6-13)
  ABACUS_ARITHMETIC_ADD_LEVEL_6_SECTION_1: '10 примера 3-4D10R абакус',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_6_SECTION_2: '20 примера 3D2D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_6_SECTION_3: '20 примера 3-4D/2-3D',
  ABACUS_ARITHMETIC_ADD_LEVEL_6_SECTION_4: '10 примера 2D4R',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_6_SECTION_5: '20 примера 2-3D1D',
  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_1: '10 примера 2-3D10R абакус',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_7_SECTION_2: '20 примера 2D*2D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_7_SECTION_3: '20 примера 3-4D/1D',
  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_4: '10 примера 1D7R',
  ABACUS_ARITHMETIC_ADD_LEVEL_7_SECTION_5: '10 примера 1-2D5R',
  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_1: '10 примера 2D10R абакус',
  ABACUS_ARITHMETIC_MULTIPLICATION_LEVEL_8_SECTION_2: '20 примера 3D*1D',
  ABACUS_ARITHMETIC_DIVISION_LEVEL_8_SECTION_3: '20 примера 2-3D/1D',
  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_4: '10 примера 1D6R',
  ABACUS_ARITHMETIC_ADD_LEVEL_8_SECTION_5: '10 примера 1-2D4R',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_1: '20 примера таблица на умножението',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_2: '10 примера 1-2D10R абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_3: '10 примера 2D4R абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_4: '10 примера 1D4R',
  ABACUS_ARITHMETIC_ADD_LEVEL_9_SECTION_5: '10 примера 1D5R',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_1: '20 примера състав на числото 10',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_2: '10 примера 1D10R абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_3: '10 примера 2D4RF5 абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_4: '10 примера 1D5RF5',
  ABACUS_ARITHMETIC_ADD_LEVEL_10_SECTION_5: '10 примера 1D4RF10',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_1: '20 примера състав на числото 10',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_2: '10 примера 1D8RF10 абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_3: '10 примера 2D3RF5 абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_4: '10 примера 1D5RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_11_SECTION_5: '10 примера 1D3RF5',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_1: '20 примера състав на числото 10',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_2: '10 примера 1D6RF5 абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_3: '10 примера 2D3RNF абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_4: '10 примера 1D4RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_12_SECTION_5: '20 примера флашкарти 2D',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_1: '20 примера състав на числото 5',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_2: '10 примера 1D5RNF абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_3:
    '10 огледални примера 2D3RNF абакус',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_4: '10 примера 1D3RNF',
  ABACUS_ARITHMETIC_ADD_LEVEL_13_SECTION_5: '20 примера флашкарти 1D',
  // UI/Management
  VISIBILITY: 'Видимост',
  HISTORY_TITLE: 'История на операциите',
  OLIMP_PURCHASES: 'Покупки за олимпиада',
  CREATOR: 'Създател',
  // News
  files: 'Файлове',
  fullscreen: 'Цял екран',
  DROP_FILES: 'Натиснете, преместете или поставете файлове за качване...',
  NEWS_TYPE: 'Тематика на новината',
  DEFAULT_NEWS: 'Обикновена',
  UPDATE_NEWS: 'Актуализация',
  FEATHERS_NEWS: 'Пера',
  WHITE_NEWS: 'Бяла',
  BLUE_NEWS: 'Синя',
  RED_NEWS: 'Червена',
  YELLOW_NEWS: 'Жълта',
  GREEN_NEWS: 'Зелена',
  PURPLE_NEWS: 'Лилава',
  NEWS_UNCHECKED: 'Какво ново имаме тук?',
  NEWS_CHECKED: 'Това вече го гледахме',
  NEWS_CHECKED_ALL: 'Вие сте наясно с всички събития! Така трябва!',
  NEWS_HEADER: 'Ето ги новините!',
  NEWS_EMPTY: 'Все още няма новини. Но те задължително ще се появят!',
  FIRST_PAYMENT: 'Първо плащане',
  INVITED_STUDENTS_2: 'Поканени ученици',
  INVITED_TEACHERS_2: 'Поканени преподаватели',
  // Groups/Auth
  GROUP_MEMBERS: 'Състав на групата',
  RESTORE_PASSWORD: 'Възстанови парола',
  DUPLICATES_TITLE: 'Може би това е вашият акаунт?',
  DIRECTORY_DUPLICATES_TITLE: 'Намерени са подобни',
  REGISTER_NEW: 'Регистрирай нов',
  DELETE_CONFIRM: 'Потвърдете изтриването',

  // register forms
  REGISTER_AS: 'Като кого искате да се регистрирате в платформата?',
  REGISTER_AS_PARENT: 'Като родител на ученик',
  REGISTER_AS_TEACHER: 'Като преподавател',
  // ACHIEVEMENTS
  // student
  'achievement.student.first_homework.title': 'Началото е поставено',
  'achievement.student.first_homework.desc':
    'Направи първата си домашна работа, така продължавай!',
  'achievement.student.2_homeworks_per_day.title': 'Веднъж, и още веднъж!',
  'achievement.student.2_homeworks_per_day.desc':
    'Днес това вече е втората ти домашна работа. Не те спира нищо!',
  'achievement.student.homeworks_for_week_comleted.title': 'По-лесно от лесно!',
  'achievement.student.homeworks_for_week_comleted.desc':
    'Браво, справяш се с цялата домашна работа вече цяла седмица!',
  'achievement.student.homeworks_for_month_comleted.title': 'Мисията изпълнена',
  'achievement.student.homeworks_for_month_comleted.desc':
    'Възхитени сме от твоята издръжливост! Изпълняваше цялата домашна работа в продължение на месец.',
  'achievement.student.10_homeworks_completed.title': 'Малък, но юнак!',
  'achievement.student.10_homeworks_completed.desc':
    'Отлично! Вече направи 10 домашни работи в портала.',
  'achievement.student.50_homeworks_completed.title': 'Има резултат!',
  'achievement.student.50_homeworks_completed.desc':
    'Отлично! Вече направи 50 домашни работи в портала.',
  'achievement.student.100_homeworks_completed.title': 'Не ме спира нищо!',
  'achievement.student.100_homeworks_completed.desc':
    'Отлично! Вече направи 100 домашни работи в портала.',
  'achievement.student.500_homeworks_completed.title':
    'Безкрайността не е граница!',
  'achievement.student.500_homeworks_completed.desc':
    'Отлично! Вече направи 500 домашни работи в портала.',
  'achievement.student.set_avatar.title': 'Усмивчица!',
  'achievement.student.set_avatar.desc':
    'Награда за задаване или смяна на аватара на профила',
  'achievement.student.first_olimpic.title': 'Опитът не е мъчение',
  'achievement.student.first_olimpic.desc':
    'Поздравления за първото участие в олимпиада!',
  'achievement.student.olimpic_prize_place.title': 'Дайте ми награда!',
  'achievement.student.olimpic_prize_place.desc':
    'Поздравления за призово място в олимпиадата!',
  'achievement.student.olimpic_first_place.title': 'Най-добрият от всички!',
  'achievement.student.olimpic_first_place.desc':
    'Поздравления за победа в олимпиадата!',
  'achievement.student.first_exam_access.title': 'Готов съм!',
  'achievement.student.first_exam_access.desc':
    'Реши да положиш първия си изпит, така продължавай!',
  'achievement.student.access_3_month.title': 'Заедно е по-весело...',
  'achievement.student.access_3_month.desc':
    'Ура! Занимаваш се с нас вече 3 месеца подред.',
  'achievement.student.access_6_month.title': 'Половин година, като един ден.',
  'achievement.student.access_6_month.desc':
    'Ура! Занимаваш се с нас вече 6 месеца подред.',
  'achievement.student.access_12_month.title': 'Не се отклонявам от пътя...',
  'achievement.student.access_12_month.desc':
    'Ура! Занимаваш се с нас вече цяла година.',
  'achievement.student.student_try_uamap.title': 'Не само да гледам!',
  'achievement.student.student_try_uamap.desc':
    'Награда за първия опит за симулация на изпит UAMAP',
  'achievement.student.student_try_sama_mental.title':
    'Началото на менталния път...',
  'achievement.student.student_try_sama_mental.desc':
    'Награда за първия опит за симулация на изпит ментална PAMA GLOBAL',
  'achievement.student.student_try_sama_abacus.title':
    'В началото беше абакусът...',
  'achievement.student.student_try_sama_abacus.desc':
    'Награда за първия опит за симулация на изпит PAMA GLOBAL на абакус',
  'achievement.student.uamap_13.title': 'Медал UAMAP 13',
  'achievement.student.uamap_13.desc':
    'Поздравления, положи изпит UAMAP 13-то ниво!',
  'achievement.student.uamap_12.title': 'Медал UAMAP 12',
  'achievement.student.uamap_12.desc':
    'Поздравления, положи изпит UAMAP 12-то ниво!',
  'achievement.student.uamap_11.title': 'Медал UAMAP 11',
  'achievement.student.uamap_11.desc':
    'Поздравления, положи изпит UAMAP 11-то ниво!',
  'achievement.student.uamap_10.title': 'Медал UAMAP 10',
  'achievement.student.uamap_10.desc':
    'Поздравления, положи изпит UAMAP 10-то ниво!',
  'achievement.student.uamap_9.title': 'Медал UAMAP 9',
  'achievement.student.uamap_9.desc':
    'Поздравления, положи изпит UAMAP 9-то ниво!',
  'achievement.student.uamap_8.title': 'Медал UAMAP 8',
  'achievement.student.uamap_8.desc':
    'Поздравления, положи изпит UAMAP 8-то ниво!',
  'achievement.student.uamap_7.title': 'Медал UAMAP 7',
  'achievement.student.uamap_7.desc':
    'Поздравления, положи изпит UAMAP 7-мо ниво!',
  'achievement.student.uamap_6.title': 'Медал UAMAP 6',
  'achievement.student.uamap_6.desc':
    'Поздравления, положи изпит UAMAP 6-то ниво!',
  'achievement.student.sama_abacus_12.title': 'Орден Абакус PAMA GLOBAL 12',
  'achievement.student.sama_abacus_12.desc':
    'Поздравления, положи изпит абакус PAMA GLOBAL 12-то ниво!',
  'achievement.student.sama_abacus_11.title': 'Орден Абакус PAMA GLOBAL 11',
  'achievement.student.sama_abacus_11.desc':
    'Поздравления, положи изпит абакус PAMA GLOBAL 11-то ниво!',
  'achievement.student.sama_abacus_10.title': 'Орден Абакус PAMA GLOBAL 10',
  'achievement.student.sama_abacus_10.desc':
    'Поздравления, положи изпит абакус PAMA GLOBAL 10-то ниво!',
  'achievement.student.sama_abacus_9.title': 'Орден Абакус PAMA GLOBAL 9',
  'achievement.student.sama_abacus_9.desc':
    'Поздравления, положи изпит абакус PAMA GLOBAL 9-то ниво!',
  'achievement.student.sama_abacus_8.title': 'Орден Абакус PAMA GLOBAL 8',
  'achievement.student.sama_abacus_8.desc':
    'Поздравления, положи изпит абакус PAMA GLOBAL 8-мо ниво!',
  'achievement.student.sama_abacus_7.title': 'Орден Абакус PAMA GLOBAL 7',
  'achievement.student.sama_abacus_7.desc':
    'Поздравления, положи изпит абакус PAMA GLOBAL 7-мо ниво!',
  'achievement.student.sama_abacus_6.title': 'Орден Абакус PAMA GLOBAL 6',
  'achievement.student.sama_abacus_6.desc':
    'Поздравления, положи изпит абакус PAMA GLOBAL 6-то ниво!',
  'achievement.student.sama_abacus_5.title': 'Орден Абакус PAMA GLOBAL 5',
  'achievement.student.sama_abacus_5.desc':
    'Поздравления, положи изпит абакус PAMA GLOBAL 5-то ниво!',
  'achievement.student.sama_abacus_4.title': 'Орден Абакус PAMA GLOBAL 4',
  'achievement.student.sama_abacus_4.desc':
    'Поздравления, положи изпит абакус PAMA GLOBAL 4-то ниво!',
  'achievement.student.sama_abacus_3.title': 'Орден Абакус PAMA GLOBAL 3',
  'achievement.student.sama_abacus_3.desc':
    'Поздравления, положи изпит абакус PAMA GLOBAL 3-то ниво!',
  'achievement.student.sama_abacus_2.title': 'Орден Абакус PAMA GLOBAL 2',
  'achievement.student.sama_abacus_2.desc':
    'Поздравления, положи изпит абакус PAMA GLOBAL 2-ро ниво!',
  'achievement.student.sama_abacus_1.title': 'Орден Абакус PAMA GLOBAL 1',
  'achievement.student.sama_abacus_1.desc':
    'Поздравления, положи изпит абакус PAMA GLOBAL 1-во ниво!',
  'achievement.student.sama_mental_12.title': 'Корона Ментална PAMA GLOBAL 12',
  'achievement.student.sama_mental_12.desc':
    'Поздравления, положи изпит ментална PAMA GLOBAL 12-то ниво!',
  'achievement.student.sama_mental_11.title': 'Корона Ментална PAMA GLOBAL 11',
  'achievement.student.sama_mental_11.desc':
    'Поздравления, положи изпит ментална PAMA GLOBAL 11-то ниво!',
  'achievement.student.sama_mental_10.title': 'Корона Ментална PAMA GLOBAL 10',
  'achievement.student.sama_mental_10.desc':
    'Поздравления, положи изпит ментална PAMA GLOBAL 10-то ниво!',
  'achievement.student.sama_mental_9.title': 'Корона Ментална PAMA GLOBAL 9',
  'achievement.student.sama_mental_9.desc':
    'Поздравления, положи изпит ментална PAMA GLOBAL 9-то ниво!',
  'achievement.student.sama_mental_8.title': 'Корона Ментална PAMA GLOBAL 8',
  'achievement.student.sama_mental_8.desc':
    'Поздравления, положи изпит ментална PAMA GLOBAL 8-мо ниво!',
  'achievement.student.sama_mental_7.title': 'Корона Ментална PAMA GLOBAL 7',
  'achievement.student.sama_mental_7.desc':
    'Поздравления, положи изпит ментална PAMA GLOBAL 7-мо ниво!',
  'achievement.student.sama_mental_6.title': 'Корона Ментална PAMA GLOBAL 6',
  'achievement.student.sama_mental_6.desc':
    'Поздравления, положи изпит ментална PAMA GLOBAL 6-то ниво!',
  'achievement.student.sama_mental_5.title': 'Корона Ментална PAMA GLOBAL 5',
  'achievement.student.sama_mental_5.desc':
    'Поздравления, положи изпит ментална PAMA GLOBAL 5-то ниво!',
  'achievement.student.sama_mental_4.title': 'Корона Ментална PAMA GLOBAL 4',
  'achievement.student.sama_mental_4.desc':
    'Поздравления, положи изпит ментална PAMA GLOBAL 4-то ниво!',
  'achievement.student.sama_mental_3.title': 'Корона Ментална PAMA GLOBAL 3',
  'achievement.student.sama_mental_3.desc':
    'Поздравления, положи изпит ментална PAMA GLOBAL 3-то ниво!',
  'achievement.student.sama_mental_2.title': 'Корона Ментална PAMA GLOBAL 2',
  'achievement.student.sama_mental_2.desc':
    'Поздравления, положи изпит ментална PAMA GLOBAL 2-ро ниво!',
  'achievement.student.sama_mental_1.title': 'Корона Ментална PAMA GLOBAL 1',
  'achievement.student.sama_mental_1.desc':
    'Поздравления, положи изпит ментална PAMA GLOBAL 1-во ниво!',
  // teacher
  'achievement.teacher.first_student_exam_completed.title': 'Първият тръгна!',
  'achievement.teacher.first_student_exam_completed.desc':
    '1 ученик положи какъвто и да е изпит',
  'achievement.teacher.10_student_exams_completed.title': 'Събра отбор!',
  'achievement.teacher.10_student_exams_completed.desc':
    '10 ученици положиха какъвто и да е изпит',
  'achievement.teacher.50_student_exams_completed.title': 'Наставник',
  'achievement.teacher.50_student_exams_completed.desc':
    '50 ученици положиха какъвто и да е изпит',
  'achievement.teacher.homeworks_for_week_comleted.title': 'Показа как',
  'achievement.teacher.homeworks_for_week_comleted.desc':
    'Поздравления, вашият ученик се справяше с домашната работа цяла седмица!',
  'achievement.teacher.olimpic_prize_1.title': 'Сподели опит',
  'achievement.teacher.olimpic_prize_1.desc':
    'Поздравления, вашият ученик зае призово място в олимпиадата!',
  'achievement.teacher.olimpic_prize_3.title': 'Сенсей',
  'achievement.teacher.olimpic_prize_3.desc':
    'Поздравления, 3 ваши ученици заеха призово място в олимпиадата!',
  'achievement.teacher.olimpic_prize_5.title': 'Мъдър учител',
  'achievement.teacher.olimpic_prize_5.desc':
    'Поздравления, 5 ваши ученици заеха призово място в олимпиадата!',
  'achievement.teacher.10_homeworks_created.title': 'Не е време за почивка!',
  'achievement.teacher.10_homeworks_created.desc':
    'Не е лошо! Вече зададохте 10 домашни задания на своите ученици.',
  'achievement.teacher.100_homeworks_created.title': 'Познавам си работата!',
  'achievement.teacher.100_homeworks_created.desc':
    'Не е лошо! Вече зададохте 100 домашни задания на своите ученици.',
  'achievement.teacher.500_homeworks_created.title': 'Много не е малко!',
  'achievement.teacher.500_homeworks_created.desc':
    'Не е лошо! Вече зададохте 500 домашни задания на своите ученици.',
  'achievement.teacher.referal_created_student_1.title': '(+1)',
  'achievement.teacher.referal_created_student_1.desc':
    'Поздравления! Доведохте нов ученик в платформата!',
  'achievement.teacher.referal_created_student_5.title': 'Заедно е по-весело',
  'achievement.teacher.referal_created_student_5.desc':
    'Поздравления! Вече доведохте 5 ученици в платформата!',
  'achievement.teacher.referal_created_student_10.title': 'Ние сме отбор!',
  'achievement.teacher.referal_created_student_10.desc':
    'Поздравления! Вече доведохте 10 ученици в платформата!',
  'achievement.teacher.referal_created_teacher_1.title': 'Вече не сам!',
  'achievement.teacher.referal_created_teacher_1.desc':
    'Поздравления! Доведохте нов преподавател в платформата!',
  'achievement.teacher.referal_created_teacher_3.title': 'Всички свои!',
  'achievement.teacher.referal_created_teacher_3.desc':
    'Поздравления! Вече доведохте 3 преподаватели в платформата!',
  'achievement.teacher.referal_created_teacher_5.title': 'Обичам си работата!',
  'achievement.teacher.referal_created_teacher_5.desc':
    'Поздравления! Вече доведохте 5 преподаватели в платформата!',
  'achievement.teacher.pay_for_student_access.title': 'Принос в бъдещето',
  'achievement.teacher.pay_for_student_access.desc':
    'Току-що платихте абонамента на вашия ученик за платформата. Получете своята награда!',
  'achievement.teacher.pay_for_student_olimpic.title': 'Проява на грижа',
  'achievement.teacher.pay_for_student_olimpic.desc':
    'Току-що платихте участието на вашия ученик в олимпиада. Получете своята награда!',
  'achievement.teacher.topup_account.title': 'Точно ще потрябва!',
  'achievement.teacher.topup_account.desc':
    'Попълнихте баланса и за това получавате малък подарък!',
  'achievement.teacher.set_avatar.title': 'Усмивчица!',
  'achievement.teacher.set_avatar.desc':
    'Награда за задаване или смяна на аватара на профила',
  'achievement.teacher.complete_profile.title': 'Свой човек!',
  'achievement.teacher.complete_profile.desc':
    'Награда за попълване на всички полета в профила',
  'achievement.teacher.uamap_1.title': 'Сертификат UAMAP 1',
  'achievement.teacher.uamap_1.desc':
    'Поздравления, успешно положихте изпит UAMAP 1-во ниво',
  'achievement.teacher.uamap_2.title': 'Сертификат UAMAP 2',
  'achievement.teacher.uamap_2.desc':
    'Поздравления, успешно положихте изпит UAMAP 2-ро ниво',
  'achievement.teacher.uamap_3.title': 'Сертификат UAMAP 3',
  'achievement.teacher.uamap_3.desc':
    'Поздравления, успешно положихте изпит UAMAP 3-то ниво',
  'achievement.teacher.sama_3.title': '3 звезди PAMA GLOBAL',
  'achievement.teacher.sama_3.desc':
    'Поздравления, получихте 3 звезди PAMA GLOBAL',
  'achievement.teacher.sama_5.title': '2 звезди PAMA GLOBAL',
  'achievement.teacher.sama_5.desc':
    'Поздравления, получихте 2 звезди PAMA GLOBAL',
  'achievement.teacher.sama_7.title': 'Звезда PAMA GLOBAL',
  'achievement.teacher.sama_7.desc':
    'Поздравления, получихте 1 звезда PAMA GLOBAL',
  // other
  SOUND_ON: 'вкл',
  DAILY: 'Ежедневно',
  COMPLETE_BY: 'Изпълни до',
  SPECIFIC_DAYS: 'На определени дни',
  SPECIFIC_DAYS_MULTIPLE:
    'На определени дни (могат да се посочат няколко дати)',
  MONTHS_LIST:
    'Януари,Февруари,Март,Април,Май,Юни,Юли,Август,Септември,Октомври,Ноември,Декември',
  MONTHS_SHORT: 'яну,фев,мар,апр,май,юни,юли,авг,сеп,окт,ное,дек',
  WEEKDAYS_LONG: 'Неделя,Понеделник,Вторник,Сряда,Четвъртък,Петък,Събота',
  WEEKDAYS_SHORT: 'нд,пн,вт,ср,чт,пт,сб',
  NEXT_MONTH: 'следващ месец',
  PREVIOUS_MONTH: 'предишен месец',
  GENDER_MALE: 'Мъжки',
  GENDER_FEMALE: 'Женски',
  THEME_STANDARD: 'Стандартни',
  THEME_STANDARD_DESC: 'Теми на оформление, достъпни за всички потребители',
  THEME_UNIQUE: 'Уникални',
  THEME_UNIQUE_DESC: 'Теми на оформление, достъпни за магически пера',
  BRAND_THEME: 'Фирмена тема',
  ABACUS_COLOR_CHOICE: 'Тук можеш да избереш цвета на костите за своя абакус',
  EGYPT_THEME_DESC:
    'Потопете се в атмосферата на древен Египет, където светът е пълен с тайни и загадки!',
  INSTALL: 'Инсталирай',
  OWL_GREETING: 'Здравей, казвам се кукумявката Юни',
  CONFIGURE_TRAINER: 'Настрой тренажора',
  CHOOSE_TASK_TEXT: 'Избери подходяща задача и ме удиви с резултата',
  QUICK_START: 'Бърз старт',
  QUICK_START_DESC:
    'Натисни да тренираш точно сега с набор от случайни настройки',
  // Schulte
  TABLE_SIZE: 'Размер на таблицата',
  NUMBER_DIGITS: 'Разредност на числата',
  SHUFFLE_ON_CLICK: 'Разбъркване при клик',
  CENTER_DOT: 'Точка в центъра',
  SYMBOL_ORDER: 'Ред на символите',
  TABLE_TYPE: 'Тип на таблицата',
  DIRECT_ORDER: 'Прав',
  REVERSE_ORDER: 'Обратен',
  RANDOM_ORDER: 'Случаен',
  NUMBERS: 'Цифри',
  SOUND_VOLUME: 'Сила на звука',
  FIND_SYMBOL: 'Намери символа',
  // other
  DIGIT_RANGE: 'Разредност',
  FOR_WHOM: 'За кого',
  REDUCE_TABLE: 'Намали таблицата',

  // correct or wrong phrases when user solves samples
  OWL_SUCCESS_1: 'When you solve the problem correctly',
  OWL_SUCCESS_2: 'Simply excellent',
  OWL_SUCCESS_3: 'Ha, easy peasy!',
  OWL_SUCCESS_4: "You're incredibly awesome",
  OWL_SUCCESS_5: 'Answer is correct',
  OWL_SUCCESS_6: 'Excellent work',
  OWL_SUCCESS_7: 'Got a perfect score',
  OWL_SUCCESS_8: "That's just awesome!",
  OWL_SUCCESS_9: 'You did it?!',
  OWL_SUCCESS_10: 'Super smart',
  OWL_SUCCESS_11: "Let's keep going!",
  OWL_SUCCESS_12: 'Nailed it!',
  OWL_SUCCESS_13: 'Easy win',
  OWL_SUCCESS_14: 'YOSH!',
  OWL_SUCCESS_15: 'Incredible!',
  OWL_SUCCESS_16: 'You did it!',
  OWL_SUCCESS_17: 'The sharpest answer in the Wild West',
  OWL_SUCCESS_18: 'Humanity has never been this close to perfection!',

  OWL_FAILED_1: 'Unfortunately, no…',
  OWL_FAILED_2: "Looks like someone's too chill today",
  OWL_FAILED_3: 'Oh my god',
  OWL_FAILED_4: 'Answer is incorrect…',
  OWL_FAILED_5: 'Are you sure you signed up for mental arithmetic?',
  OWL_FAILED_6: 'Wrong approach',
  OWL_FAILED_7: 'Nope!',
  OWL_FAILED_8: 'Another try?',
  OWL_FAILED_9: 'I disapprove',
  OWL_FAILED_10: "Don't be upset...",
  OWL_FAILED_11: 'Try again…',
  OWL_FAILED_12: 'I really believed in you...',
  OWL_FAILED_13: 'Again...',
  OWL_FAILED_14: 'If you struggle long enough, something will work out!',
  OWL_FAILED_15: 'Well, shoot',
  OWL_FAILED_16: 'Years of effort, mountains of trying, all for this',
  OWL_FAILED_17: 'What could have gone wrong this time?',
  OWL_FAILED_18: 'Next time it will work!',
  // other
  FULLSCREEN: 'На цял екран',
  EXIT_FULLSCREEN: 'Изход от цял екран',
  CURRENT_RANK: 'Текущото ти звание е:',
  PAST_WINNERS: 'Минали победители',
  WINNER_TABLE_CREATE_TITLE: 'Добави нов победител',
  EDIT_WINNER_TITLE: 'Редактирай победител',
  CHOOSE_OLIMPIC_NAME: 'Избери олимпиада',
  CONFIRM_DELETE_WINNER:
    'Сигурни ли сте, че искате да изтриете записа за победителя?',
  FILE_SIZE_ERROR: 'Изберете снимка с размер не повече от 3 МБ',
  FILE_TYPE_ERROR:
    'Невалиден тип файл. Моля, качете изображение (JPEG, PNG и т.н.).',
  SAVE_WINNERS_RESULT: 'Запази резултатите',
  CONFIRM_SAVE_WINNERS:
    'Сигурни ли сте, че искате да запазите резултатите? ВАЖНО! Трябва да са посочени местата.',
  NO_PLACES_WARNING: 'Не са посочени места 0/1!',
  IMPORTANT_FIELDS_LOCKED:
    'Редактирането на име, фамилия и дата на раждане е възможно само веднъж. При възникване на въпроси се обърнете към администратора.',
  LOGIN_CHANGE_CONFIRM:
    'След редактиране на имейла в профила, имейлът за вход в личния кабинет се промени.',
  TEMPLATES: 'Шаблони',
  DIPLOMS_RECORDS_TEMPLATES: 'Шаблони за записи в дипломи',
  MAIN_TEMPLATE: 'Шаблон по подразбиране',
  CONFIRM_DELETE_TEMPLATE: 'Сигурни ли сте, че искате да изтриете този шаблон?',
  TEMPLATE_CREATE_TITLE: 'Създай шаблон',
  TEMPLATE_EDIT_TITLE: 'Редактирай шаблон',
  TEMPLATE_SUCCESS_CREATE_MESSAGE: 'Шаблонът е създаден успешно',
  TEMPLATE_SUCCESS_EDIT_MESSAGE: 'Шаблонът е актуализиран успешно',
  ADD_STAGE: 'Добави етап',
  ADD_CATEGORY: 'Добави категория',
  VARIANT: 'Тип смятане',
  SHORT_RECORD: 'Кратък запис',
  CATEGORY_NAME: 'Название на категорията',
  CATEGORY_NAME_VALIDATION:
    'Названието на категорията трябва да съдържа само главни латински букви и цифри',
  SAMPLES_TYPE: 'Тип задача',
  TEMPLATE_FORM_TEXT: 'Изберете шаблон за записи в дипломи',
  // Рейтинг звезд
  BEST_STUDENTS: 'НАЙ-ДОБРИТЕ УЧЕНИЦИ',
  RESET_STARS: 'Нулирай звездите',
  OPEN_ALL: 'Отвори всички',
  LOADING: 'Зареждане...',
  TAB_IN_SCHOOL: 'В училище',
  TAB_WITH_TEACHER: 'При педагога',
  TAB_IN_GROUP: 'В група',
  NO_RATING_DATA: 'В рейтинга все още няма ученици',
  SCHOOL_STAR_RATING: 'Рейтинг на училището',
  GROUPS_STAR_RATING: 'Рейтинг по групи',
  TEACHER_STAR_RATING: 'Рейтинг по педагог',
  CONFIRM_RESET_STARS:
    'Сигурни ли сте, че искате да нулирате звездите на всички ваши ученици?',
  CONFIRM_RESET_SCHOOL_STARS:
    'Сигурни ли сте, че искате да нулирате звездите на тези ученици?',
  RATING_SCHOOL_MESSAGE:
    'Изберете ученици (ваши и на учителите), за да нулирате звездите',
  NO_TEACHERS: 'Не са намерени учители',
  STAR_RATING_CLUE:
    'Звезди за домашните на вашите ученици. Можете да награждавате учениците по свое усмотрение, повишавайки по този начин мотивацията на децата. Наградите, датите за обобщаване на резултатите и броят на местата са по ваш избор.',
  SETTING_ON: 'вкл',
  SMGL_USERS_TITLE: 'PAMA потребители',
  OPERATION_COMPLETED: 'Операцията е изпълнена',
  DELETED_COUNT: 'Изтрити: {count}',
  SHOW_RATING_FOR_UAMAP: 'Покажи рейтинга в Uamap',
  PAMA_GLOBAL_RATING: 'Рейтинг PAMA Global',
  SHOW_IN_ROW: 'Покажи в ред',
  PAMA_GLOBAL_PRINT: 'Печат на задачи PAMA Global',
  PAMA_OFFLINE_OLIMPIC: 'Очна PAMA Global',
  PAMA_OFFLINE_FOR_STUDENT: 'Очна PAMA Global за ученик',
  PAMA_OFFLINE_FOR_TEACHER: 'Очна PAMA Global за педагог',
  MAINTAINER_PAMA: 'Придружител PAMA Global',
  PAMA_OFFLINE_PARTICIPANTS: 'Участници в Очна PAMA Global',
  PAMA_OFFLINE_OLIMPIC_PAYMENT:
    'Покупка на участие в Очна PAMA GLOBAL олимпиада',
  MAINTAINER_PAMA_PAYMENT: 'Придружител към Очна PAMA GLOBAL олимпиада',
  PAMA_OFFLINE_OLIMPIC_PAY_PARTICIPATE:
    'Плати за участие в очна PAMA Global олимпиада',
  // ..
  PRACTICE_ON_TAB: 'Тренирайте в раздела',
  WITH_ACTIVE_ACCESS: 'с активен достъп на нашата платформа',
  ACCOMPANY_PARTICIPANT_TEXT:
    'Ако планирате да придружавате участника, закупете билет и за него',
  CURRENT_COMPANION_LIMIT: 'Текущ лимит на придружителите:',
  COMPANION_SALES_CLOSED: 'Продажбата на билети за придружители е затворена',
  PURCHASED_TEXT: 'Придобито:',
  COMPANION_TICKET_ONE: 'билет',
  COMPANION_TICKET_TWO: 'билета',
  COMPANION_TICKET_FIVE: 'билета',
  OF_COMPANIONS: 'придружители',
  TICKET_DATA_WARNING:
    'Следните данни ще бъдат използвани за създаване на билета, моля, проверете за точност',
  TICKET_EMAIL_DELIVERY_PAMA:
    'Билетът трябва да бъде изпратен на посочения имейл в определените срокове.',
  TICKET_EMAIL_DELIVERY_OLIMPIC:
    'Билетът трябва да бъде изпратен на посочения имейл в рамките на 3-5 работни дни. Ако това не се е случило, моля, свържете се с',
  TELEGRAM_LINK_TEXT: 'Телеграм',
  EDIT_PROFILE_IF_ERROR: 'В случай на грешка, редактирайте своя профил',
  PHOTO_UPLOAD_NOTICE:
    'Качете снимка с размер не повече от 10 МБ на всяко облачно пространство. Копирайте връзката и я поставете тук. Проверете дали достъпът по връзката е отворен.',
  SELECT_CATEGORY_PLACEHOLDER: 'Изберете категория',
  SELECT_COUNTRY_PLACEHOLDER: 'Изберете държава',
  RULES_AGREEMENT:
    'Прочетох регламента на олимпиадата и приемам всички описани в него правила.',
  CATEGORY_WARNING:
    'Изберете категория строго по-висока, ако преди това сте заемали призово място. Възможни са дисквалификации при неспазване на правилото.',
  MAINTAINERS_LIMIT_REACHED: 'Достигнат е максималният брой придружители.',
  STUDENT_TABLE_REGISTER_NOTICE:
    'Задължително регистрирайте потребителя за олимпиадата в неговия личен кабинет',
  COMPANION_REGISTRATION_REQUIRED:
    'За покупката е необходимо да регистрирате потребителя за олимпиадата',
  MAINTAINERS_ONE_PURCHASE: '1 Придружител / Придобий',
  MAINTAINERS_OTHER_PURCHASE: '{count} Придружители / Придобий',
  OFFICIAL_MODE: 'Превключи от тренировъчни на официални PAMA примери',
  NUMBERS_TITLE: 'Числа на памет',
  LENGTH_WORD: 'Дължина',
  DIGITS_SHORT: 'зн.',
  PROGRESS_WORD: 'Прогрес',
  WRITE_ANSWER_INTERMEDIATE: 'Запишете отговора! Ново число след...',
  WRITE_ANSWER: 'Запишете отговора!',
  PAUSE: 'Пауза',
  CHECK_ANSWERS: 'Проверете своите отговори.',
  STAGE_FINISHED: 'Етапът е завършен!',
  NUMBER_WORD: 'Число',
  buy_books: 'Купи учебници',
  CHAMPION_OF_CHAMPIONS: 'Супершампион',
  // new
  MAINTAINERS_REGISTRATION_FORM: 'Формуляр за регистрация на придружители',
  REGISTER_MAINTAINERS: 'Регистрирай придружители',
  HIDE_MAINTAINERS_FORM: 'Скрий формуляра за придружители',
  MAINTAINERS_SUCCESS_SAVED: 'Придружителите са успешно регистрирани',
  PHOTO_LINK_MAINTAINER: 'Връзка към снимка на придружител',
  RELATION: 'Роля',
  RELATION_PARENT: 'Родител',
  RELATION_TEACHER: 'Педагог',
  MAINTAINERS_FILL_ALL_FIELDS:
    'Попълнете всички задължителни полета за поне един придружител',
  MAINTAINERS: 'Придружители',

  MAINTAINERS_LOADED_COUNT: 'Заредени придружители: {count}',
  UNFILLED_MAINTAINERS: 'Незарег. придружители',
  EDIT_MAINTAINER: 'Редактиране на придружител',
  CONFIRM_DELETE_MAINTAINER:
    'Сигурни ли сте, че искате да изтриете този придружител? Броят на билетите за придружители на участника ще бъде намален с 1.',
  FULL_NAME_EN: 'Име и фамилия на английски',
  DONT_SHOW_AGAIN: 'Не показвай повече',
  PRINT_ALL_STAGES: 'Разпечатай всички етапи наведнъж',
};
